import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, Subscribable, Subscription, of} from 'rxjs';
import { catchError, first, map, mergeMap, timeout } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { AnyAaaaRecord } from 'dns';

@Injectable({
  providedIn: 'root',
})
export class LivewalkTestService {
  statusSubject: Subject<any> = new Subject();
  stoppedRule: Subject<any> = new Subject();
  disableActions: Subject<any> = new Subject();
  walktestFilterSubject: Subject<any> = new Subject();
  walktestEventSubject: Subject<any> = new Subject();
  walktestReportDataSubject: Subject<any> = new Subject();
  joinLiveSubject: Subject<any> = new Subject();
  triggerDetailedSubmit: Subject<any>;
  detailedreportMesage: Subject<any> = new Subject();
  popupObservable: Subject<any> = new Subject();

  A: string = 'frgrtyhyujhogdrt';
  B: string = 'wdvfrtghyujkimlo';

  allAvailableTestTypes = [];
  continuoustests = {};
  singletests = {};
  applicationsingle = {};
  applicationscontinuous = {};
  allTestsMapping: any = {};
  walktesttypeMapping: any = {};

   testTypeMapping: any = {
    curl: 'CURL',
    curl_continuous: 'CURLCONTI',
    'curl-continuous': 'CURLCONTI',
    ping: 'PING',
    ping_continuous: 'PINGCONTI',
    'ping-continuous': 'PINGCONTI',
    'rf-continuous': 'RF',
    'rf-pindrop': 'PINRF',
    'iperf-pindrop': 'PINIPERF',
    'iperf-continuous': 'IPERF',
    '3_min': 'PINRF',
    continuous: 'RF',
    iperf: 'PINIPERF',
    iperf_continuous: 'IPERF',
    ytube_continuous: 'YOUTUBE',
    ytube: 'PINYOUTUBE',
    'youtube-pindrop': 'PINYOUTUBE',
    'youtube-continuous': 'YOUTUBE',
    'speed-continuous': 'SPEEDCONTI',
    speed: 'SPEED',
    sptest_continuous: 'SPEEDCONTI',
    sptest: 'SPEED',
    video_single: 'VIDEO',
    video_continuous: 'VIDEOCONTI',
    call: 'CALL',
    call_continuous: 'CALLCONTI',
    'call-continuous': 'CALLCONTI',
    'rrc-single': 'RRC',
    'rrc-continuous': 'RRCCONTI',
    gnss: 'GNSS',
    'gnss-continuous': 'GNSSCONTI',
    'gnss_continuous': 'GNSSCONTI',
    'rrc_state':'RRC',
    "rrc_state_continuous":"RRCCONTI"
  };

  getPopupObservable() {
    return this.popupObservable.asObservable();
  }

  getNewInstanceOfTriggerDetailedSubmit() {
    this.triggerDetailedSubmit = new Subject();
    return this.triggerDetailedSubmit;
  }
  getCurrentInstanceOfTriggeredDetailedSubmit() {
    return this.triggerDetailedSubmit;
  }

  getDesableObs() {
    return this.disableActions.asObservable();
  }
  getStoppedRule() {
    return this.stoppedRule.asObservable();
  }
  devicesWithTestStartedStatus = [];
  typeMapping = {};
  // {
  //   RF: 'continuous', PINRF: '3_min', IPERF: 'iperf_continuous', PINIPERF: 'iperf', PING:'ping', CURL:"curl", CURLCONTI:"curl_continuous", PINGCONTI:"ping_continuous",
  //   PINYOUTUBE:"ytube", YOUTUBE:"ytube_continuous", SPEED:"sptest", SPEEDCONTI:"sptest_continuous", VIDEO:"video_single", "VIDEOCONTI":"video_continuous", CALL:"call",
  //   CALLCONTI:"call_continuous", RRC:"rrc_status", RRCCONTI:"rrc_status_continuous",
  // }
  baseInfo = {
    a_IMEI: '-',
    'c_Scan Time': '-',
    'b_Connected To': '-',
    d_Duration: '-',
  };

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getVideoServerIpPort(locname?: any) {
    let op = new Observable((subscriber) => {
      subscriber.next({ port: 1234 });
    });
    return op;
  }

  downloadCSV(ruleids:any,time?:any,mapid?:any, deviceid?:any) {
    const filter = {ruleids,time,mapid, deviceid};
    let api = `${this.fileServerUrl}/csvdownload/generatecsv`;
    return this.httpClient.post(api, filter, { responseType: 'blob' });
  }

  checkfor5GNetworkPresence(survey) {
    let network = '';
    if (survey) {
      for (let i = survey.length - 1; i >= 0; i--) {
        if (survey?.[i]?.servingcell) {
          if (survey?.[i]?.servingcell.includes('5G')) {
            network = network != '' ? network + ' + ' + '5G' : '5G';
          }
          if (survey?.[i]?.servingcell.includes('LTE')) {
            network = network != '' ? network + ' + ' + '4G' : '4G';
          }
        }
      }
    }
    return network;
  }

  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  time_convert(milliseconds: number) {
    if (milliseconds < 1000) {
      return `${milliseconds} ms`;
    } else {
      let seconds = Math.floor(milliseconds / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);

      seconds = seconds % 60;
      minutes = minutes % 60;
      hours = hours % 24;

      return `${this.padTo2Digits(hours)}:${this.padTo2Digits(
        minutes
      )}:${this.padTo2Digits(seconds)}`;
    }
  }

  deleteMultipleScheduled(ids = []) {
    const options = { body: { ids: ids } };
    return this.httpClient.delete(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_mDelete`,
      options
    );
  }

  getAllTemplatesRaw() {
    return this.httpClient.get(
      this.apiEndPoint + '/gwdevice/band_template/_search?size=1000'
    );
  }

  iperfColors = [
    { value: '>=220', color: '#00FF00' },
    { value: '>=198', color: '#12FF00' },
    { value: '>=180', color: '#35FF00' },
    { value: '>=162', color: '#58FF00' },
    { value: '>=144', color: '#8DFF00' },
    { value: '>=126', color: '#B0FF00' },
    { value: '>=108', color: '#C2FF00' },
    { value: '>=90', color: '#D4FF00' },
    { value: '>=72', color: '#E5FF00' },
    { value: '>=54', color: '#FF6900' },
    { value: '>=36', color: '#FF4600' },
    { value: '>=18', color: '#FF2300' },
    { value: '>=13', color: '#fd5c63' },
    { value: '>=8', color: '#C04000' },
    { value: '>=3', color: '#C41E3A' },
    { value: '>0', color: '#58111A' },
    { value: '=0', color: '#B2BEB5' },
  ];

  jitterColors = [
    { value: '>=190', color: '#FF0000' },
    { value: '>=165', color: '#FF2300' },
    { value: '>=150', color: '#FF4600' },
    { value: '>=135', color: '#FF6900' },
    { value: '>=120', color: '#E5FF00' },
    { value: '>=105', color: '#D4FF00' },
    { value: '>=90', color: '#C2FF00' },
    { value: '>=75', color: '#B0FF00' },
    { value: '>=60', color: '#8DFF00' },
    { value: '>=45', color: '#58FF00' },
    { value: '>=30', color: '#35FF00' },
    { value: '>=15', color: '#12FF00' },
    { value: '>=0', color: '#00FF00' },
  ];

  rssiColorArray = [
    { value: '>-30.00', color: '#B2FFFF' },
    { value: '>-35.00', color: '#7FFFD4' },
    { value: '>-40.00', color: '#89CFF0' },
    { value: '>-45.00', color: '#6699CC' },
    { value: '>-50.00', color: '#318CE7' },
    { value: '>-55.00', color: '#5072A7' },
    { value: '>-60.00', color: '#e1bee7' },
    { value: '>-65.00', color: '#e040fb' },
    { value: '>-70.00', color: '#e57373' },
    { value: '>-75.00', color: '#8e24aa' },
    { value: '>-80.00', color: '#00e676' },
    { value: '>-85.00', color: '#afb42b' },
    { value: '>-90.00', color: '#388e3c' },
    { value: '>-95.00', color: '#1b5e20' },
    { value: '>-100.00', color: '#eeff41' },
    { value: '>-105.00', color: '#ef6c00' },
    { value: '>-110.00', color: '#ff3d00' },
    { value: '<= -110.00', color: '#132257' },
  ];

  rsrqColorArray = [
    { value: '>=0.00', color: '#FF4500' },
    { value: '>-5.00', color: '#32CD32' },
    { value: '>-10.00', color: '#8B0000' },
    { value: '>-15.00', color: '#FFD700' },
    { value: '>-20.00', color: '#00CED1' },
    { value: '>-25.00', color: '#FF1493' },
    { value: '>-30.00', color: '#B2FFFF' },
    { value: '>-35.00', color: '#7FFFD4' },
    { value: '>-40.00', color: '#89CFF0' },
    { value: '>-45.00', color: '#6699CC' },
    { value: '>-50.00', color: '#318CE7' },
    { value: '>-55.00', color: '#5072A7' },
    { value: '>-60.00', color: '#e1bee7' },
    { value: '>-65.00', color: '#e040fb' },
    { value: '>-70.00', color: '#e57373' },
    { value: '>-75.00', color: '#8e24aa' },
    { value: '>-80.00', color: '#00e676' },
    { value: '>-85.00', color: '#afb42b' },
    { value: '>-90.00', color: '#388e3c' },
    { value: '>-95.00', color: '#1b5e20' },
    { value: '>-100.00', color: '#eeff41' },
    { value: '>-105.00', color: '#ef6c00' },
    { value: '>-110.00', color: '#ff3d00' },
    { value: '<= -110.00', color: '#132257' },
  ];

  sinrColorArray = [
    { value: '>=30', color: '#0d47a1' },
    { value: '<30 & >=25', color: '#388e3c' },
    { value: '<25 & >=20', color: '#76ff03' },
    { value: '<20 & >=15', color: '#ffff00' },
    { value: '<15 & >=10', color: '#ff9800' },
    { value: '<10 & >=5', color: '#ff3d00' },
    { value: '<5 & >=3', color: '#bdbdbd' },
    { value: '<3 ', color: '#616161' },
  ];

  constructor(
    private httpClient: HttpClient,
    @Inject('apiEndPoint') private apiEndPoint: string,
    @Inject('fileServerUrl') private fileServerUrl: string,
    @Inject('diagnosticUrl') private containerapiEndPoint
  ) {
    this.generateAvailableTests();
    this.createAllTestsMapping();
  }

  private devices = new BehaviorSubject<any>('');

  getAllDevices() {
    return this.devices.asObservable();
  }
  sendAllDevices(alldevices) {
    return this.devices.next(alldevices);
  }

  startTest(parameters) {
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/edgecontrol`,
      parameters
    );
  }

  generateRandomNum(
    length: number = 32,
    chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  ) {
    var result = '';
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result + new Date().valueOf();
  }

  setColor(param: string, para: any) {
    if (
      param == 'iperf_udp_ul_throughput' ||
      param == 'iperf_udp_dl_throughput' ||
      param == 'iperf_tcp_ul_throughput' ||
      param == 'iperf_tcp_dl_throughput'
    ) {
      return para >= 220
        ? '#00FF00'
        : para >= 198 && para <= 219.999
        ? '#12FF00'
        : para >= 180 && para <= 197.999
        ? '#35FF00'
        : para >= 162 && para <= 179.999
        ? '#58FF00'
        : para >= 144 && para <= 161.999
        ? '#8DFF00'
        : para >= 126 && para <= 143.999
        ? '#B0FF00'
        : para >= 108 && para <= 125.999
        ? '#C2FF00'
        : para >= 90 && para <= 107.999
        ? '#D4FF00'
        : para >= 72 && para <= 89.999
        ? '#E5FF00'
        : para >= 54 && para <= 71.999
        ? '#FF6900'
        : para >= 36 && para <= 53.999
        ? '#FF4600'
        : para >= 18 && para <= 35.999
        ? '#FF2300'
        : // para >= 0.01 && para <= 17.9999 ? '#FF0000' :
        para >= 13 && para <= 17.9999
        ? '#fd5c63'
        : para >= 8 && para <= 12.9999
        ? '#C04000'
        : para >= 3 && para <= 7.9999
        ? '#C41E3A'
        : para >= 0.0009 && para <= 2.9999
        ? '#58111A'
        : '#B2BEB5';
    } else if (
      param == 'iperf_udp_dl_jitter' ||
      param == 'iperf_udp_ul_jitter' ||
      param == 'totaltime'
    ) {
      return para >= 190
        ? '#FF0000'
        : para >= 165 && para <= 190.999
        ? '#FF2300'
        : para >= 150 && para <= 164.999
        ? '#FF4600'
        : para >= 135 && para <= 149.999
        ? '#FF6900'
        : para >= 120 && para <= 134.999
        ? '#E5FF00'
        : para >= 105 && para <= 119.999
        ? '#D4FF00'
        : para >= 90 && para <= 104.999
        ? '#C2FF00'
        : para >= 75 && para <= 89.999
        ? '#B0FF00'
        : para >= 60 && para <= 74.999
        ? '#8DFF00'
        : para >= 45 && para <= 59.999
        ? '#58FF00'
        : para >= 30 && para <= 44.999
        ? '#35FF00'
        : para >= 15 && para <= 29.999
        ? '#12FF00'
        : para >= 0 && para <= 14.9999
        ? '#00FF00'
        : '#00FF00';
    } else if (param == 'sinr') {
      return para >= 30
        ? '#0d47a1'
        : para < 30 && para >= 25
        ? '#388e3c'
        : para < 25 && para >= 20
        ? '#76ff03'
        : para < 20 && para >= 15
        ? '#ffff00'
        : para < 15 && para >= 10
        ? '#ff9800'
        : para < 10 && para >= 5
        ? '#ff3d00'
        : para < 5 && para >= 3
        ? '#bdbdbd'
        : para < 3
        ? '#616161'
        : '#0d47a1';
    } else if (param == 'upload' || param == 'download') {
      //for sptest
      return para >= 190
        ? '#00FF00'
        : para >= 165 && para <= 190.999
        ? '#12FF00'
        : para >= 150 && para <= 164.999
        ? '#35FF00'
        : para >= 135 && para <= 149.999
        ? '#58FF00'
        : para >= 120 && para <= 134.999
        ? '#8DFF00'
        : para >= 105 && para <= 119.999
        ? '#B0FF00'
        : para >= 90 && para <= 104.999
        ? '#C2FF00'
        : para >= 75 && para <= 89.999
        ? '#D4FF00'
        : para >= 60 && para <= 74.999
        ? '#E5FF00'
        : para >= 45 && para <= 59.999
        ? '#FF6900'
        : para >= 30 && para <= 44.999
        ? '#FF4600'
        : para >= 15 && para <= 29.999
        ? '#FF2300'
        : para >= 0 && para <= 14.9999
        ? '#FF0000'
        : '#FF0000';
    } else if (
      param == 'pkts_tx' ||
      param == 'pkts_rx' ||
      param == 'audio_jitter_std' ||
      param == 'video_jitter_std'
    ) {
      //for ping
      return para >= 190
        ? '#FF0000'
        : para >= 165 && para <= 190.999
        ? '#FF2300'
        : para >= 150 && para <= 164.999
        ? '#FF4600'
        : para >= 135 && para <= 149.999
        ? '#FF6900'
        : para >= 120 && para <= 134.999
        ? '#E5FF00'
        : para >= 105 && para <= 119.999
        ? '#D4FF00'
        : para >= 90 && para <= 104.999
        ? '#C2FF00'
        : para >= 75 && para <= 89.999
        ? '#B0FF00'
        : para >= 60 && para <= 74.999
        ? '#8DFF00'
        : para >= 45 && para <= 59.999
        ? '#58FF00'
        : para >= 30 && para <= 44.999
        ? '#35FF00'
        : para >= 15 && para <= 29.999
        ? '#12FF00'
        : para >= 0 && para <= 14.9999
        ? '#00FF00'
        : '#00FF00';
    } else if (param == 'pkt_loss') {
      //for ping
      return para >= 100
        ? ' #FF0000'
        : para >= 90 && para <= 99.999
        ? '  #FF4600'
        : para >= 80 && para <= 89.999
        ? ' #FF6900'
        : para >= 70 && para <= 79.999
        ? ' #FFAC1C'
        : para >= 60 && para <= 69.999
        ? ' #B0FF00'
        : para >= 50 && para <= 59.999
        ? ' #8DFF00'
        : para >= 40 && para <= 49.999
        ? ' #58FF00'
        : para >= 30 && para <= 39.999
        ? ' #35FF00'
        : para >= 20 && para <= 29.999
        ? ' #12FF00'
        : para >= 10 && para <= 19.999
        ? ' #00FF00'
        : para >= 0 && para <= 9.9999
        ? ' #008000'
        : ' #008000';
    } else if (
      param == 'average_download_speed_mbps' ||
      param == 'bitrate' ||
      param == 'fps' ||
      param == 'speed'
    ) {
      //for ytube
      return para >= 190
        ? '#00FF00'
        : para >= 165 && para <= 190.999
        ? '#12FF00'
        : para >= 150 && para <= 164.999
        ? '#35FF00'
        : para >= 135 && para <= 149.999
        ? '#58FF00'
        : para >= 120 && para <= 134.999
        ? '#8DFF00'
        : para >= 105 && para <= 119.999
        ? '#B0FF00'
        : para >= 90 && para <= 104.999
        ? '#C2FF00'
        : para >= 75 && para <= 89.999
        ? '#D4FF00'
        : para >= 60 && para <= 74.999
        ? '#E5FF00'
        : para >= 45 && para <= 59.999
        ? '#FF6900'
        : para >= 30 && para <= 44.999
        ? '#FF4600'
        : para >= 15 && para <= 29.999
        ? '#FF2300'
        : para >= 0 && para <= 14.9999
        ? '#FF0000'
        : '#FF0000';
    } else if (param == 'overall_quality_assessment') {
      //for ytube
      return para == 'Poor'
        ? '#FF2300'
        : para == 'Fair'
        ? '#E5FF00'
        : para == 'Good'
        ? '#8DFF00'
        : para == 'Excellent'
        ? '#00FF00'
        : '#808080';
    } else if (
      param == 'ALERTING' ||
      param == 'ORIGINATING' ||
      param == 'CONNECTED'
    ) {
      //for call status
      return param == 'ALERTING' && para
        ? '#a6eb47ff'
        : param == 'ORIGINATING' && para
        ? '#61c008ff'
        : param == 'CONNECTED' && para
        ? '#097909ff'
        : '#808080';
    } else if (param == 'GPS') {
      return '#388e3c';
    } else {
      if (para == 99) {
        return '#808080';
      } else if (param == 'rsrq') {
        return para <= -116
          ? '#132257'
          : para >= -115 && para <= -110
          ? '#132257'
          : para >= -109 && para <= -105
          ? '#ff3d00'
          : para >= -104 && para <= -100
          ? '#ef6c00'
          : para >= -99 && para <= -95
          ? '#eeff41'
          : para >= -94 && para <= -90
          ? '#1b5e20'
          : para >= -89 && para <= -85
          ? '#388e3c'
          : para >= -84 && para <= -80
          ? '#afb42b'
          : para >= -79 && para <= -75
          ? '#00e676'
          : para >= -74 && para <= -70
          ? '#8e24aa'
          : para >= -69 && para <= -65
          ? '#e57373'
          : para >= -64 && para <= -60
          ? '#e040fb'
          : para >= -59 && para <= -55
          ? '#e1bee7'
          : para >= -54 && para <= -50
          ? '#5072A7'
          : para >= -49 && para <= -45
          ? '#318CE7'
          : para >= -44 && para <= -40
          ? '#6699CC'
          : para >= -39 && para <= -35
          ? '#89CFF0'
          : para >= -34 && para <= -30
          ? '#7FFFD4'
          : para >= -29 && para <= -25
          ? '#B2FFFF'
          : para >= -24 && para <= -20
          ? '#FF1493'
          : para >= -19 && para <= -15
          ? '#00CED1'
          : para >= -14 && para <= -10
          ? '#FFD700'
          : para >= -9 && para <= -5
          ? '#8B0000'
          : para >= -4 && para <= 0
          ? '#32CD32'
          : para >= 0
          ? '#FF4500'
          : '#FF4500';
      } else {
        return para <= -116
          ? '#132257'
          : para >= -115 && para <= -110
          ? '#132257'
          : para >= -109 && para <= -105
          ? '#ff3d00'
          : para >= -104 && para <= -100
          ? '#ef6c00'
          : para >= -99 && para <= -95
          ? '#eeff41'
          : para >= -94 && para <= -90
          ? '#1b5e20'
          : para >= -89 && para <= -85
          ? '#388e3c'
          : para >= -84 && para <= -80
          ? '#afb42b'
          : para >= -79 && para <= -75
          ? '#00e676'
          : para >= -74 && para <= -70
          ? '#8e24aa'
          : para >= -69 && para <= -65
          ? '#e57373'
          : para >= -64 && para <= -60
          ? '#e040fb'
          : para >= -59 && para <= -55
          ? '#e1bee7'
          : para >= -54 && para <= -50
          ? '#5072A7'
          : para >= -49 && para <= -45
          ? '#318CE7'
          : para >= -44 && para <= -40
          ? '#6699CC'
          : para >= -39 && para <= -35
          ? '#89CFF0'
          : para >= -34 && para <= -30
          ? '#7FFFD4'
          : para >= -29 && para <= -25
          ? '#B2FFFF'
          : '#B2FFFF';
      }
    }
  }

  colorGenerator(arr = [], keys = []) {
    const colorObj = {};
    keys.map((key) => {
      colorObj[key] = {};
    });
    arr.map((each) => {
      if (each?.color) {
        keys.map((k) => {
          colorObj[k][each.color] = 0;
        });
      }
    });
    return colorObj;
  }

  pingColor_pkttxrx = [
    { value: '>= 190', color: '#00FF00' },
    { value: '>= 165', color: '#00FF00' },
    { value: '>= 150', color: '#12FF00' },
    { value: '>= 135', color: '#35FF00' },
    { value: '>= 120', color: '#58FF00' },
    { value: '>= 105', color: '#8DFF00' },
    { value: '>= 90', color: '#B0FF00' },
    { value: '>= 75', color: '#C2FF00' },
    { value: '>= 60', color: '#D4FF00' },
    { value: '>= 45', color: '#E5FF00' },
    { value: '>= 30', color: '#FF6900' },
    { value: '>= 15', color: '#FF4600' },
    { value: '>= 0', color: '#FF2300' },
  ];

  pingColor_pktloss = [
    { value: '= 100', color: ' #FF0000' },
    { value: '>= 90', color: ' #FF4600' },
    { value: '>= 80', color: ' #FF6900' },
    { value: '>= 70', color: ' #FFAC1C' },
    { value: '>= 60', color: ' #B0FF00' },
    { value: '>= 50', color: ' #8DFF00' },
    { value: '>= 40', color: ' #58FF00' },
    { value: '>= 30', color: ' #35FF00' },
    { value: '>= 20', color: ' #12FF00' },
    { value: '>= 10', color: ' #00FF00' },
    { value: '>= 0', color: ' #008000' },
  ];
  speed_updn = [
    { value: '>= 190', color: '#00FF00' },
    { value: '>= 165', color: '#12FF00' },
    { value: '>= 150', color: '#35FF00' },
    { value: '>= 135', color: '#58FF00' },
    { value: '>= 120', color: '#8DFF00' },
    { value: '>= 105', color: '#B0FF00' },
    { value: '>= 90', color: '#C2FF00' },
    { value: '>= 75', color: '#D4FF00' },
    { value: '>= 60', color: '#E5FF00' },
    { value: '>= 45', color: '#FF6900' },
    { value: '>= 30', color: '#FF4600' },
    { value: '>= 15', color: '#FF2300' },
    { value: '>= 0', color: '#FF0000' },
  ];
  ytube_dl = [
    { value: '>= 190', color: '#00FF00' },
    { value: '>= 165', color: '#12FF00' },
    { value: '>= 150', color: '#35FF00' },
    { value: '>= 135', color: '#58FF00' },
    { value: '>= 120', color: '#8DFF00' },
    { value: '>= 105', color: '#B0FF00' },
    { value: '>= 90', color: '#C2FF00' },
    { value: '>= 75', color: '#D4FF00' },
    { value: '>= 60', color: '#E5FF00' },
    { value: '>= 45', color: '#FF6900' },
    { value: '>= 30', color: '#FF4600' },
    { value: '>= 15', color: '#FF2300' },
    { value: '>= 0', color: '#FF0000' },
  ];

  yube_qlty = [
    { value: 'Poor', color: '#FF2300' },
    { value: 'Fair', color: '#E5FF00' },
    { value: 'Good', color: '#8DFF00' },
    { value: 'Excellent', color: '#00FF00' },
  ];

  audio_jitter = [
    { value: '>=190', color: '#FF0000' },
    { value: '>=165', color: '#FF2300' },
    { value: '>=150', color: '#FF4600' },
    { value: '>=135', color: '#FF6900' },
    { value: '>=120', color: '#E5FF00' },
    { value: '>=105', color: '#D4FF00' },
    { value: '>=90', color: '#C2FF00' },
    { value: '>=75', color: '#B0FF00' },
    { value: '>=60', color: '#8DFF00' },
    { value: '>=45', color: '#58FF00' },
    { value: '>=30', color: '#35FF00' },
    { value: '>=15', color: '#12FF00' },
    { value: '>=0', color: '#00FF00' },
  ];

  video_jitter = [
    { value: '>=190', color: '#FF0000' },
    { value: '>=165', color: '#FF2300' },
    { value: '>=150', color: '#FF4600' },
    { value: '>=135', color: '#FF6900' },
    { value: '>=120', color: '#E5FF00' },
    { value: '>=105', color: '#D4FF00' },
    { value: '>=90', color: '#C2FF00' },
    { value: '>=75', color: '#B0FF00' },
    { value: '>=60', color: '#8DFF00' },
    { value: '>=45', color: '#58FF00' },
    { value: '>=30', color: '#35FF00' },
    { value: '>=15', color: '#12FF00' },
    { value: '>=0', color: '#00FF00' },
  ];

  bitrateColorArray = [
    { value: '>=190', color: '#00FF00' },
    { value: '>=165', color: '#12FF00' },
    { value: '>=150', color: '#35FF00' },
    { value: '>=135', color: '#58FF00' },
    { value: '>=120', color: '#8DFF00' },
    { value: '>=105', color: '#B0FF00' },
    { value: '>=90', color: '#C2FF00' },
    { value: '>=75', color: '#D4FF00' },
    { value: '>=60', color: '#E5FF00' },
    { value: '>=45', color: '#FF6900' },
    { value: '>=30', color: '#FF4600' },
    { value: '>=15', color: '#FF2300' },
    { value: '>=0', color: '#FF0000' },
  ];

  fpsColorArray = [
    { value: '>=190', color: '#00FF00' },
    { value: '>=165', color: '#12FF00' },
    { value: '>=150', color: '#35FF00' },
    { value: '>=135', color: '#58FF00' },
    { value: '>=120', color: '#8DFF00' },
    { value: '>=105', color: '#B0FF00' },
    { value: '>=90', color: '#C2FF00' },
    { value: '>=75', color: '#D4FF00' },
    { value: '>=60', color: '#E5FF00' },
    { value: '>=45', color: '#FF6900' },
    { value: '>=30', color: '#FF4600' },
    { value: '>=15', color: '#FF2300' },
    { value: '>=0', color: '#FF0000' },
  ];

  speedColorArray = [
    { value: '>=190', color: '#00FF00' },
    { value: '>=165', color: '#12FF00' },
    { value: '>=150', color: '#35FF00' },
    { value: '>=135', color: '#58FF00' },
    { value: '>=120', color: '#8DFF00' },
    { value: '>=105', color: '#B0FF00' },
    { value: '>=90', color: '#C2FF00' },
    { value: '>=75', color: '#D4FF00' },
    { value: '>=60', color: '#E5FF00' },
    { value: '>=45', color: '#FF6900' },
    { value: '>=30', color: '#FF4600' },
    { value: '>=15', color: '#FF2300' },
    { value: '>=0', color: '#FF0000' },
  ];

  call_ColorArray = [
    { value: 'Alerted', color: '#a6eb47ff' },
    { value: 'Dialed', color: '#61c008ff' },
    { value: 'Responded', color: '#097909ff' },
  ];

  gpsColorArray = [{ value: 'GPS', color: '#388e3c' }];

  testparamTypeMap: any = {};
  allowedCellular: any = {};
  allowedWifi: any = {};
  testtypeParameterMaps: any = {};
  testWiseAllParameters: any = {
    //testname order matters fist is continuous and second is single
    RF: [
      {
        id: 1,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rssi',
        value: 'rssi',
        name: 'RSSI',
        param: 'rssi',
        searchKey: 'rssi',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 2,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'rsrp',
        value: 'rsrp',
        name: 'RSRP',
        param: 'rsrp',
        searchKey: 'rsrp',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 3,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'rsrq',
        value: 'rsrq',
        name: 'RSRQ',
        param: 'rsrq',
        searchKey: 'rsrq',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 4,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'sinr',
        value: 'sinr',
        name: 'SINR',
        param: 'sinr',
        searchKey: 'sinr',
        type: 'rf',
        testName: ['continuous', '3_min'],
        dname: 'RF',
        catagory: 'RF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
    ],
    IPERF: [
      {
        id: 5,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rssi',
        value: 'rssi',
        name: 'RSSI',
        param: 'rssi',
        searchKey: 'rssi',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 6,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rsrp',
        value: 'rsrp',
        name: 'RSRP',
        param: 'rsrp',
        searchKey: 'rsrp',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 7,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'rsrq',
        value: 'rsrq',
        name: 'RSRQ',
        param: 'rsrq',
        searchKey: 'rsrq',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 8,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'sinr',
        value: 'sinr',
        name: 'SINR',
        param: 'sinr',
        searchKey: 'sinr',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 9,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'tcp_ul',
        value: 'iperf_tcp_ul_throughput',
        name: 'TCP UL',
        param: 'iperf_tcp_ul_throughput',
        searchKey: 'tcp_ul',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 10,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'tcp_dl',
        value: 'iperf_tcp_dl_throughput',
        name: 'TCP DL',
        param: 'iperf_tcp_dl_throughput',
        searchKey: 'tcp_dl',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 11,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'udp_ul',
        value: 'iperf_udp_ul_throughput',
        name: 'UDP UL',
        param: 'iperf_udp_ul_throughput',
        searchKey: 'udp_ul',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 12,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'udp_dl',
        value: 'iperf_udp_dl_throughput',
        name: 'UDP DL',
        param: 'iperf_udp_dl_throughput',
        searchKey: 'udp_dl',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 13,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'ul_jitter',
        value: 'iperf_udp_ul_jitter',
        name: 'UL JITTER',
        param: 'iperf_udp_ul_jitter',
        searchKey: 'ul_jitter',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
      {
        id: 14,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'dl_jitter',
        value: 'iperf_udp_dl_jitter',
        name: 'DL JITTER',
        param: 'iperf_udp_dl_jitter',
        searchKey: 'dl_jitter',
        type: 'iperf',
        testName: ['iperf_continuous', 'iperf'],
        dname: 'IPERF',
        catagory: 'IPERF Test',
        testtype: 'cellular',
        allowed: { wifi: true, cellular: true },
      },
    ],
    Youtube: [
      {
        id: 15,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'average_download_speed_mbps',
        value: 'average_download_speed_mbps',
        name: 'Average Download Speed',
        param: 'average_download_speed_mbps',
        searchKey: 'average_download_speed_mbps',
        type: 'ytube',
        catagory: 'Youtube Test',
        testName: ['ytube_continuous', 'ytube'],
        dname: 'Youtube',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'Wget Curl': [
      {
        id: 16,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'totaltime',
        value: 'totaltime',
        name: 'Total Time',
        param: 'totaltime',
        searchKey: 'curltest_total_time',
        type: 'curl',
        catagory: 'Wget URL Test',
        testName: ['curl_continuous', 'curl'],
        dname: 'Wget Curl',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
    ],
    'Speed Test': [
      {
        id: 17,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'download',
        value: 'download',
        name: 'Download Speed',
        param: 'download',
        searchKey: 'speedtest_download',
        type: 'sptest',
        catagory: 'Speed Test',
        testName: ['sptest_continuous', 'sptest'],
        dname: 'Speed Test',
        testtype: 'application',
        allowed: { cellular: true },
      },
      {
        id: 18,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'upload',
        value: 'upload',
        name: 'Upload Speed',
        param: 'upload',
        searchKey: 'speedtest_upload',
        type: 'sptest',
        catagory: 'Speed Test',
        testName: ['sptest_continuous', 'sptest'],
        dname: 'Speed Test',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'Ping Test': [
      {
        id: 19,
        allowedType: { wifi: true, cell: true },
        rangeValue: 'pkt_loss',
        value: 'pkt_loss',
        name: 'Packet Loss',
        param: 'pkt_loss',
        searchKey: 'pkt_loss',
        type: 'ping',
        catagory: 'Ping Test',
        testName: ['ping_continuous', 'ping'],
        dname: 'Ping Test',
        testtype: 'application',
        allowed: { wifi: true, cellular: true },
      },
    ],
    'Video Single': [
      {
        id: 20,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'bitrate',
        value: 'bitrate',
        name: 'Bitrate',
        param: 'bitrate',
        searchKey: 'bitrate',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 21,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'fps',
        value: 'fps',
        name: 'Framerate',
        param: 'fps',
        searchKey: 'fps',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 22,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'speed',
        value: 'speed',
        name: 'Speed',
        param: 'speed',
        searchKey: 'speed',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 23,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'audio_jitter',
        value: 'audio_jitter_std',
        name: 'Audio Jitter',
        param: 'audio_jitter_std',
        searchKey: 'audio_jitter_std',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
      {
        id: 24,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'video_jitter',
        value: 'video_jitter_std',
        name: 'Video Jitter',
        param: 'video_jitter_std',
        searchKey: 'video_jitter_std',
        type: 'video',
        catagory: 'Video Test',
        testName: ['video_continuous', 'video_single'],
        dname: 'Video Single',
        testtype: 'cellular',
        allowed: { cellular: true },
      },
    ],
    Call: [
      {
        id: 26,
        value: 'ORIGINATING',
        allowedType: { wifi: true, cell: true },
        rangeValue: 'ORIGINATING',
        bypassRange: true,
        name: 'Dialed',
        param: 'ORIGINATING',
        searchKey: 'ORIGINATING',
        type: 'call',
        catagory: 'Call Test',
        testName: ['dialnumber_continuous', 'dialnumber'],
        alias: ['call_continuous', 'call'],
        dname: 'Call',
        testtype: 'application',
        allowed: { cellular: true },
      },
      {
        id: 25,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'ALERTING',
        bypassRange: true,
        value: 'ALERTING',
        name: 'Alerted',
        param: 'ALERTING',
        searchKey: 'ALERTING',
        type: 'call',
        catagory: 'Call Test',
        testName: ['dialnumber_continuous', 'dialnumber'],
        alias: ['call_continuous', 'call'],
        dname: 'Call',
        testtype: 'application',
        allowed: { cellular: true },
      },

      {
        id: 27,
        value: 'CONNECTED',
        allowedType: { wifi: true, cell: true },
        rangeValue: 'CONNECTED',
        bypassRange: true,
        name: 'Responded',
        param: 'CONNECTED',
        searchKey: 'CONNECTED',
        type: 'call',
        catagory: 'Call Test',
        testName: ['dialnumber_continuous', 'dialnumber'],
        alias: ['call_continuous', 'call'],
        dname: 'Call',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'Fast Gps': [
      {
        id: 28,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'GPS',
        bypassRange: true,
        value: 'GPS',
        name: 'GPS',
        param: 'GPS',
        searchKey: 'GPS',
        type: 'gnss',
        catagory: 'Fast Gps',
        testName: ['gnss_continuous', 'gnss'],
        dname: 'Fast Gps',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
    'RRC State': [
      {
        id: 29,
        allowedType: { wifi: false, cell: true },
        rangeValue: 'rrc_param',
        bypassRange: true,
        value: 'rrc_param',
        name: 'RRC State',
        param: 'rrc_param',
        searchKey: 'rrc_param',
        type: 'rrc',
        catagory: 'RRC State',
        testName: ['rrc_state_continuous', 'rrc_state'],
        dname: 'RRC State',
        testtype: 'application',
        allowed: { cellular: true },
      },
    ],
  };

  childPopupNameMapping = {
    rf: {
      val: 'rf-pindrop',
      type: 'PINRF',
      displayName: 'RF Configurations',
      parameter: '3_min',
      testname: 'RF Pindrop',
      catagory: 'RF',
      userDisplayname: 'RF (Pindrop)',
      parameter_other: undefined,
    },
    rfc: {
      val: 'rf-continuous',
      type: 'RF',
      displayName: 'RF Configurations',
      parameter: 'continuous',
      testname: 'RF Continuous',
      catagory: 'RF',
      userDisplayname: 'RF (Continuous)',
      parameter_other: undefined,
    },
    iperf: {
      val: 'iperf-pindrop',
      type: 'PINIPERF',
      displayName: 'IPERF Configurations:',
      parameter: 'iperf',
      testname: 'IPERF Pindrop',
      catagory: 'IPERF',
      userDisplayname: 'IPERF (Pindrop)',
      parameter_other: undefined,
    },
    iperfc: {
      val: 'iperf-continuous',
      type: 'IPERF',
      displayName: 'IPERF Configurations:',
      parameter: 'iperf_continuous',
      testname: 'IPERF Continuous',
      catagory: 'IPERF',
      userDisplayname: 'IPERF (Continuous)',
      parameter_other: undefined,
    },
    ping: {
      val: 'ping',
      type: 'PING',
      displayName: 'Ping Configurations',
      parameter: 'ping',
      testname: 'Ping Test',
      catagory: 'PING',
      userDisplayname: 'Ping (Pindrop)',
      parameter_other: undefined,
    },
    pingc: {
      val: 'ping-continuous',
      type: 'PINGCONTI',
      displayName: 'Ping Configurations',
      parameter: 'ping_continuous',
      testname: 'Ping Continuous',
      catagory: 'PING',
      userDisplayname: 'Ping (Continuous)',
      parameter_other: undefined,
    },
    curl: {
      val: 'curl',
      type: 'CURL',
      displayName: 'Wget Url Configurations',
      parameter: 'curl',
      testname: 'Curl Test',
      catagory: 'CURL',
      userDisplayname: 'Wget url (Pindrop)',
      parameter_other: undefined,
    },
    curlc: {
      val: 'curl-continuous',
      type: 'CURLCONTI',
      displayName: 'Wget Url Configurations',
      parameter: 'curl_continuous',
      testname: 'Curl Continuous',
      catagory: 'CURL',
      userDisplayname: 'Wget url (Continuous)',
      parameter_other: undefined,
    },
    ytube: {
      val: 'youtube-pindrop',
      type: 'PINYOUTUBE',
      displayName: 'Youtube Configurations',
      parameter: 'ytube',
      testname: 'Youtube Pindrop',
      catagory: 'YOUTUBE',
      userDisplayname: 'Youtube (Pindrop)',
      parameter_other: undefined,
    },
    ytubec: {
      val: 'youtube-continuous',
      type: 'YOUTUBE',
      displayName: 'Youtube Configurations',
      parameter: 'ytube_continuous',
      testname: 'Youtube Continuous',
      catagory: 'YOUTUBE',
      userDisplayname: 'Youtube (Continuous)',
      parameter_other: undefined,
    },
    speed: {
      val: 'speed',
      type: 'SPEED',
      displayName: 'Speed Test Configurations',
      parameter: 'sptest',
      testname: 'Speed',
      catagory: 'SPEED',
      userDisplayname: 'Speed (Pindrop)',
      parameter_other: undefined,
    },
    speedc: {
      val: 'speed-continuous',
      type: 'SPEEDCONTI',
      displayName: 'Speed Test Configurations',
      parameter: 'sptest_continuous',
      testname: 'Speed Continuous',
      catagory: 'SPEED',
      userDisplayname: 'Speed (Continuous)',
      parameter_other: undefined,
    },
    video: {
      val: 'video_single',
      type: 'VIDEO',
      displayName: 'Video Test Configurations',
      parameter: 'video_single',
      testname: 'Video',
      catagory: 'VIDEO',
      userDisplayname: 'Video (Pindrop)',
      parameter_other: undefined,
    },
    videoc: {
      val: 'video-continuous',
      type: 'VIDEOCONTI',
      displayName: 'Video Test Configurations',
      parameter: 'video_continuous',
      testname: 'Video Continuous',
      catagory: 'VIDEO',
      userDisplayname: 'Video (Continuous)',
      parameter_other: undefined,
    },
    call: {
      val: 'call',
      type: 'CALL',
      displayName: 'Call Setup Configurations',
      parameter: 'call',
      testname: 'Call',
      catagory: 'CALL',
      userDisplayname: 'Call setup (Pindrop)',
      parameter_other: 'dialnumber',
    },
    callc: {
      val: 'call-continuous',
      type: 'CALLCONTI',
      displayName: 'Call Setup Configurations',
      parameter: 'call_continuous',
      testname: 'Call Continuous',
      catagory: 'CALL',
      userDisplayname: 'Call setup (Continuous)',
      parameter_other: 'dialnumber_continuous',
    },
    rrc: {
      val: 'rrc-single',
      type: 'RRC',
      displayName: 'RRC State Configurations',
      parameter: 'rrc_state',
      testname: 'RRC Single',
      catagory: 'RRC',
      userDisplayname: 'RRC State (Pindrop)',
      parameter_other: undefined,
    },
    rrcc: {
      val: 'rrc-continuous',
      type: 'RRCCONTI',
      displayName: 'RRC State Configurations',
      parameter: 'rrc_state_continuous',
      testname: 'RRC Continuous',
      catagory: 'RRC',
      userDisplayname: 'RRC State (Continuous)',
      parameter_other: undefined,
    },
    gnss: {
      val: 'gnss',
      type: 'GNSS',
      displayName: 'GNSS Configurations',
      parameter: 'gnss',
      testname: 'GNSS Single',
      catagory: 'GNSS',
      userDisplayname: 'Fast Gps (Pindrop)',
      parameter_other: undefined,
    },
    gnssc: {
      val: 'gnss-continuous',
      type: 'GNSSCONTI',
      displayName: 'GNSS Configurations',
      parameter: 'gnss_continuous',
      testname: 'GNSS Continuous',
      catagory: 'GNSS',
      userDisplayname: 'Fast Gps (Continuous)',
      parameter_other: undefined,
    },
  };

  allTestMappngDragdrop: any = {};
  testDisplayNames: any = {};
  testtype;
  createAllTestsMapping() {
    const allTestsMapping: any = {};
    const allTestMappngDragdrop: any = {};
    const othernamesMaps: any = {};
    const typeMapping: any = {};
    Object.entries(this.childPopupNameMapping).forEach(([key, value]) => {
      const {
        type,
        testname,
        parameter,
        catagory,
        userDisplayname,
        parameter_other,
      } = value;
      allTestsMapping[type] = {
        name: type,
        value: testname,
        param: key,
        type: parameter,
        dname: userDisplayname,
      };

      allTestMappngDragdrop[key] = {
        name: type,
        value: testname,
        param: key,
        catagory: catagory,
      };

      if (parameter_other) {
        othernamesMaps[parameter_other] = userDisplayname;
      }
      if (parameter) {
        othernamesMaps[parameter] = userDisplayname;
      }

      typeMapping[type] = parameter;
    });
    this.allTestMappngDragdrop = allTestMappngDragdrop;
    this.allTestsMapping = allTestsMapping;
    this.testDisplayNames = othernamesMaps;
    this.typeMapping = typeMapping;
    console.log(
      'allTestsMapping',
      allTestsMapping,
      othernamesMaps,
      typeMapping,
      allTestMappngDragdrop
    );
  }

  generateAvailableTests() {
    for (let each in this.testWiseAllParameters) {
      let tests = this.testWiseAllParameters?.[each]?.[0];
      if (tests?.allowed?.cellular) {
        this.allowedCellular[tests?.dname] = true;
      }
      if (tests?.allowed?.wifi) {
        this.allowedWifi[tests?.dname] = true;
      }
      if (tests?.testName) {
        console.log(tests?.othernames);
        this.continuoustests[tests?.testName?.[0]] =
          tests?.othernames?.[tests?.testName?.[0]] || tests?.testName?.[0];
        this.singletests[tests?.testName?.[1]] =
          tests?.othernames?.[tests?.testName?.[1]] || tests?.testName?.[1];
        if (tests?.testtype == 'application') {
          if (tests?.testName?.[0]) {
            this.applicationscontinuous[tests?.testName?.[0]] =
              tests?.othernames?.[tests?.testName?.[0]] || tests?.testName?.[0];
          }

          if (tests?.testName?.[1]) {
            this.applicationsingle[tests?.testName?.[1]] =
              tests?.othernames?.[tests?.testName?.[1]] || tests?.testName?.[1];
          }
        }

        let conti = [];
        let single = [];
        this.testWiseAllParameters?.[each].map((parameter: any) => {
          conti.push({
            value: parameter?.value,
            name: parameter?.name,
            id: parameter?.id,
            dispname: `Continuous (${parameter?.dname})`,
          });
          single.push({
            value: parameter?.value,
            name: parameter?.name,
            id: parameter?.id,
            dispname: `Pin drop (${parameter?.dname})`,
          });
        });
        this.testtypeParameterMaps[tests?.testName?.[0]] = conti;
        this.testtypeParameterMaps[tests?.testName?.[1]] = single;

        tests?.testName.map((t) => {
          this.allAvailableTestTypes.push({
            name: t,
            dname: tests?.dname,
            type: tests?.type,
          });
          this.walktesttypeMapping[t] = {
            name: tests?.catagory,
            value: tests?.type,
            id: tests?.id,
            param: t,
            dname: tests?.dname,
          }; //csv
          this.testparamTypeMap[t] = tests?.type;
        });
      }
      if (tests?.alias) {
        //this will handle if we have given some other name
        if (tests?.alias?.[0]) {
          this.applicationscontinuous[tests?.alias?.[0]] = tests?.alias?.[0];
          this.continuoustests[tests?.alias?.[0]] = tests?.alias?.[0];
        }

        if (tests?.alias?.[1]) {
          this.applicationsingle[tests?.alias?.[1]] = tests?.alias?.[1];
          this.singletests[tests?.alias?.[1]] = tests?.alias?.[1];
        }
      }
    }
    console.log(
      this.testWiseAllParameters,
      this.allAvailableTestTypes,
      this.testparamTypeMap
    );
  }

  updatePayloadData(
    data: any,
    type: any,
    modem: any,
    modemParametersMapping: any
  ) {
    if (this.singletests?.[type]) {
      data.test_duration = 'single';
      data.ui_testtype =
        type == 'call' ? 'dialnumber' : this.singletests?.[type];
    }

    if (this.continuoustests?.[type]) {
      data.test_duration = 'continuous';
      data.ui_testtype =
        type == 'call_continuous'
          ? 'dialnumber_continuous'
          : this.continuoustests?.[type];
    }

    if (this.applicationscontinuous?.[type] || this.applicationsingle?.[type]) {
      data.condition.type = 'application';
    }

    if (type == 'iperf' || type == 'iperf_continuous') {
      data['test_id'] =
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'test_id'
        ];
    }
    return data;
  }

  parameters(
    type: string,
    modem: any,
    modemParametersMapping: any,
    currentSyncValue: any,
    defaultParameter = { value: undefined }
  ) {
    console.log(type, 'ppppppppppppppp');

    if (type == 'continuous') {
      if (
        modemParametersMapping?.[modem][this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        defaultParameter.value = 'rssi';
      } else {
        defaultParameter.value = 'rsrp';
      }
      let output = {
        rfsts: true,
        start_after:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'start_after'
          ] || 0,
        stop_after:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'stop_after'
          ] || 0,
        sync_after: currentSyncValue,
        scaninfo:
          modemParametersMapping?.[modem]?.['IPERF'] ||
          modemParametersMapping?.[modem]?.['PINIPERF'] ||
          modemParametersMapping?.[modem]?.['CURL'] ||
          modemParametersMapping?.[modem]?.['CURLCONTI'] ||
          modemParametersMapping?.[modem]?.['YOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PINYOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PING'] ||
          modemParametersMapping?.[modem]?.['PINGCONTI'] ||
          modemParametersMapping?.[modem]?.['SPEED'] ||
          modemParametersMapping?.[modem]?.['SPEEDCONTI']
            ? false
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'radio_continuous'
              ],
        serveinfo:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'serving_continuous'
          ],
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == '3_min') {
      defaultParameter.value = 'rsrp';
      let output = {
        rfsts: true,
        start_after: 0,
        stop_after: 0,
        sync_after: currentSyncValue,
        scaninfo:
          modemParametersMapping?.[modem]?.['IPERF'] ||
          modemParametersMapping?.[modem]?.['PINIPERF'] ||
          modemParametersMapping?.[modem]?.['CURL'] ||
          modemParametersMapping?.[modem]?.['CURLCONTI'] ||
          modemParametersMapping?.[modem]?.['YOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PINYOUTUBE'] ||
          modemParametersMapping?.[modem]?.['PING'] ||
          modemParametersMapping?.[modem]?.['PINGCONTI'] ||
          modemParametersMapping?.[modem]?.['SPEED'] ||
          modemParametersMapping?.[modem]?.['SPEEDCONTI']
            ? false
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'radio_pindrop'
              ],
        serveinfo:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'serving_pindrop'
          ],
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'iperf' || type == 'iperf_continuous') {
      const output = {
        duration:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'duration_continuous'
          ] ||
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'duration_pindrop'
          ],

        start_after:
          type == 'iperf'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'iperf'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        with_ping:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'with_ping'
          ] || false,
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        interface:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ],
        ip_v: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ipv4'
        ]
          ? 4
          : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'ipv6'
            ]
          ? 6
          : 4,
        port: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'server'
        ]?.['port'],
        ip: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ipv4'
        ]
          ? modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'server'
            ]?.['ip']
          : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'server'
            ]?.['ip6'],
      };

      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] != 'WiFi'
      ) {
        output['acceleration'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'acc'
          ] == 'yes'
            ? true
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'acc'
              ] == 'no'
            ? false
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'acceleration'
              ];
      }

      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ping_size'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ping_size'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'ping_size'
          ];
      }

      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'tcp_upload'
        ] ||
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'tcp_download'
        ]
      ) {
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'window'
          ]
        ) {
          output['window'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'window'
            ];
          output['tcp_sw_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'window_unit'
            ];
        }
        if (defaultParameter?.value != 'rsrp') {
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'tcp_upload'
          ]
            ? (defaultParameter.value = 'iperf_tcp_ul_throughput')
            : (defaultParameter.value = 'iperf_tcp_dl_throughput');
        }

        output['TCP'] = {
          direction:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_upload'
            ] &&
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_download'
            ]
              ? 'both'
              : modemParametersMapping?.[modem]?.[
                  this.testTypeMapping?.[type]
                ]?.['tcp_upload']
              ? 'upload'
              : 'download',
          parallel_stream:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_parallel_stream'
            ],
        };
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'length_tcp'
          ]
        ) {
          output['TCP']['length'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'length_tcp'
            ];
        }

        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'tcp_unit'
          ]
        ) {
          output['TCP']['tcp_bl_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'tcp_unit'
            ];
        }
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'udp_upload'
        ] ||
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'udp_download'
        ]
      ) {
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'buffer_size'
          ]
        ) {
          output['socket_buffer_size'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'buffer_size'
            ];
          output['socket_buffer_size_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'buffer_size_unit'
            ];
        }

        if (defaultParameter?.value != 'rsrp') {
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'udp_upload'
          ]
            ? (defaultParameter.value = 'iperf_udp_ul_throughput')
            : (defaultParameter.value = 'iperf_udp_dl_throughput');
        }

        output['UDP'] = {
          direction:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_upload'
            ] &&
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_download'
            ]
              ? 'both'
              : modemParametersMapping?.[modem]?.[
                  this.testTypeMapping?.[type]
                ]?.['udp_upload']
              ? 'upload'
              : 'download',
          udp_bitrate:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_bitrate'
            ],
          parallel_stream:
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_parallel_stream'
            ],
        };
        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'length_udp'
          ]
        ) {
          output['UDP']['length'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'length_udp'
            ];
        }

        if (
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'udp_unit'
          ]
        ) {
          output['UDP']['udp_bl_unit'] =
            modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'udp_unit'
            ];
        }
      }
      return output;
    } else if (type == 'ping' || type == 'ping_continuous') {
      // defaultParameter = 'rsrp';
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'pkt_loss';
      }
      let output = {
        start_after:
          type == 'ping'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'ping'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        url: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ],
        pktcount:
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'pkt_count'
          ],

        pktinterval:
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'pktinterval'
          ],
        pktsize:
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'pktsize'
          ],
        userapp: type,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'curl' || type == 'curl_continuous') {
      // defaultParameter = 'rsrp';
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'totaltime';
      }
      let output = {
        start_after:
          type == 'curl'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'curl'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        url: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ],
        userapp: type,
      };

      if(type == 'curl_continuous'){
                    output['iteration_count']= modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['iteration_count'];
                     output['iteration_interval']= modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.['iteration_interval'];

      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'ytube' || type == 'ytube_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'overall_quality_assessment';
      }
      let output = {
        start_after:
          type == 'ytube'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'ytube'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        url: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ],
        userapp: type,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'sptest' || type == 'sptest_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'upload';
      }
      let output = {
        start_after:
          type == 'sptest'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'sptest'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ]?.['address'],
        userapp: type,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'url'
        ]?.[0]?.server
      ) {
        output['url'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'url'
          ]?.[0]?.server;
      }

      return output;
    } else if (type == 'video_single' || type == 'video_continuous') {
      let token = localStorage.getItem('token');
      token = this.encryptUsingAES256(token);

      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'bitrate';
      }

      let output = {
        start_after:
          type == 'video_single'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'video_single'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,
        ip: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'ip'
        ],
        filename:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'file'
          ],
        path: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'path'
        ],
        server:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'server'
          ],
        port: modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'port'
        ],
        token: token,
        userapp: type,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }

      return output;
    } else if (type == 'call' || type == 'call_continuous') {
      if (
        defaultParameter?.value != 'rsrp' &&
        defaultParameter?.value != 'iperf_udp_ul_throughput' &&
        defaultParameter?.value != 'iperf_udp_dl_throughput'
      ) {
        defaultParameter.value = 'ALERTING';
      }

      let output = {
        start_after:
          type == 'call'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'call'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,

        numbertodial:
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'number'
          ],
        timetowait: !isNaN(
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'waittime'
          ]
        )
          ? +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'waittime'
            ]
          : 30,
        userapp: type == 'call' ? 'dialnumber' : 'dialnumber_continuous',
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      if (type == 'call_continuous') {
        console.log(
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'dialfrequency'
          ],
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'dialfrequencyUnit'
          ]
        );

        output['dialfrequency'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'dialfrequencyUnit'
          ] == 'Min'
            ? +modemParametersMapping?.[modem]?.[
                this.testTypeMapping?.[type]
              ]?.['dialfrequency'] * 60
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'dialfrequencyUnit'
              ] == 'Hrs'
            ? +modemParametersMapping?.[modem]?.[
                this.testTypeMapping?.[type]
              ]?.['dialfrequency'] * 3600
            : +modemParametersMapping?.[modem]?.[
                this.testTypeMapping?.[type]
              ]?.['dialfrequency'];
      }
      return output;
    } else if (type == 'rrc_state' || type == 'rrc_state_continuous') {
      let output = {
        start_after:
          type == 'rrc_state'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'rrc_state'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,

        interval: !isNaN(
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interval'
          ]
        )
          ? +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'interval'
            ]
          : 2,
        userapp: type,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      return output;
    } 
  else if (type == 'gnss' || type == 'gnss_continuous') {
      if (defaultParameter?.value != 'rsrp') {
        defaultParameter.value = 'GPS';
      }

      let output = {
        start_after:
          type == 'gnss'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'start_after'
              ] || 0,
        stop_after:
          type == 'gnss'
            ? 0
            : modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
                'stop_after'
              ] || 0,
        sync_after: currentSyncValue,

        interval: !isNaN(
          +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'gnss_interval'
          ]
        )
          ? +modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
              'gnss_interval'
            ]
          : 2,
        userapp: type,
      };
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'wifiSSID'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['ssid'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'wifiSSID'
          ];
      }
      if (
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'interface'
        ] &&
        modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
          'modem_type'
        ] == 'WiFi'
      ) {
        output['interface'] =
          modemParametersMapping?.[modem]?.[this.testTypeMapping?.[type]]?.[
            'interface'
          ];
      }
      return output;
    }
  }

  iperfParameterOrder = [
    'server',
    'port',
    'duration',
    'acceleration',
    'ip_v',
    'ip',
    'pktcount',
    'scaninfo',
    'serveinfo',
    'pktinterval',
    'pktsize',
    'ssid',
    'ping_size',
    'url',
    'dialfrequency',
    'numbertodial',
    'timetowait',
    'interval',
    'filename',
    'start_after',
    'stop_after',
    'sync_after',
  ];

  tcpUpdParameters = {
    both: ['Upload', 'Download'],
    upload: ['Upload'],
    download: ['Download'],
    parallel_stream: 'Parallel Stream',
    udp_bitrate: 'Bitrate (Mbps)',
  };

  testTypeAndKeys = {
    RF: [
      'radio_continuous',
      'serving_continuous',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    PINRF: [
      'radio_pindrop',
      'serving_pindrop',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    IPERF: [
      'index',
      'duration_continuous',
      'server',
      'ping_size',
      'acceleration',
      'bidirectional',
      'ipv4',
      'ipv6',
      'window',
      'length_tcp',
      'length_udp',
      'udp_upload',
      'udp_download',
      'tcp_upload',
      'tcp_download',
      'udp_bitrate',
      'tcp_parallel_stream',
      'udp_parallel_stream',
      'tcp_unit',
      'udp_unit',
      'window_unit',
      'buffer_size',
      'buffer_size_unit',
      'start_after',
      'stop_after',
      'sync_after',
      'with_ping',
      'tcp_buffer_default',
      'udp_buffer_default',
      'server',
      'managed','wifiSSID'
    ],
    PINIPERF: [
      'index',
      'duration_pindrop',
      'ping_size',
      'acceleration',
      'bidirectional',
      'ipv4',
      'ipv6',
      'window',
      'length_tcp',
      'length_udp',
      'udp_upload',
      'udp_download',
      'tcp_upload',
      'tcp_download',
      'udp_bitrate',
      'tcp_parallel_stream',
      'udp_parallel_stream',
      'tcp_unit',
      'udp_unit',
      'window_unit',
      'buffer_size',
      'buffer_size_unit',
      'start_after',
      'stop_after',
      'sync_after',
      'with_ping',
      'tcp_buffer_default',
      'udp_buffer_default',
      'server',
      'managed','wifiSSID'
    ],
    CALLCONTI: [
      'number',
      'waittime',
      'index',
      'callPossible',
      'dialfrequency',
      'dialfrequencyUnit',
      'start_after',
      'stop_after',
      'sync_after',
      'contact','wifiSSID'
    ],
    CALL: [
      'number',
      'waittime',
      'index',
      'callPossible',
      'start_after',
      'stop_after',
      'sync_after',
      'contact',
      'dialfrequency',
      'dialfrequencyUnit','wifiSSID'
    ],
    YOUTUBE: [
      'server',
      'url',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    PINYOUTUBE: [
      'server',
      'url',
      'urlError',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    CURLCONTI: [
      'url',
      'urlError',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    CURL: [
      'url',
      'urlError',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    GNSSCONTI: [
      'interval',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    GNSS: [
      'interval',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    PINGCONTI: [
      'url',
      'pkt_count',
      'pktinterval',
      'pktsize',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    PING: [
      'url',
      'pkt_count',
      'pktinterval',
      'pktsize',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    RRCCONTI: [
      'interval',
      'index',
      'mode',
      'interface',
      'deviceInterfaces',
      'allssids','wifiSSID'
    ],
    RRC: [
      'interval',
      'index',
      'start_after',
      'stop_after',
      'sync_after','wifiSSID'
    ],
    SPEEDCONTI: [
      'index',
      'start_after',
      'stop_after',
      'sync_after',
      'url','wifiSSID'
    ],
    SPEED: ['index','start_after', 'stop_after', 'sync_after', 'url','wifiSSID'],
  };


  valueFormatter = {
    dialfrequency: 'Call Frequency',
    '3_min': 'RF(PIN DROP)',
    iperf: ' IPERF(PIN DROP)',
    iperf_continuous: 'IPERF (CONTINUOUS)',
    continuous: 'RF (CONTINUOUS)',
    status: 'Test status',
    message: 'Reason',
    imei: 'IMEI / Interface',
    dialnumber: 'Call setup (SINGLE)',
    dialnumber_continuous: 'Call setup (CONTINUOUS)',
    scaninfo: 'RF Scan',
    serverinfo: 'Serving Cell',
    start_after: 'Start After (sec)',
    stop_after: 'Stop After (sec)',
    sync_after: 'Sync After (sec)',
    pktcount: 'Packet Count',
    ip_v: 'IP VERSION',
    ip: 'IP ADDRESS',
    ui_testtype: 'Type',
    ping_continuous: 'PING (CONTINUOUS)',
    ping: 'PING (PIN DROP)',
    curl: 'WGET URL (PIN DROP)',
    video_single: 'Video (Single)',
    video_continuous: 'Video (Continuous)',
    curl_continuous: 'WGET URL (CONTINUOUS)',
    sptest: 'SPEED (PIN DROP)',
    sptest_continuous: 'SPEED (CONTINUOUS)',
    ytube: 'YOUTUBE (PIN DROP)',
    ytube_continuous: 'YOUTUBE (CONTINUOUS)',
    numbertodial: 'Dialed Number',
    timetowait: 'Wait Time',
    serveinfo: 'Serving Cell',
    filename: 'File Name',
    rrc_status: 'RRC Status (PIN DROP)',
    rrc_status_continuous: 'RRC Status (Continuous)',
    gnss: 'Past GPS (PIN DROP)',
    gnss_continuous: 'Fast GPS (Continuous)',
  };


    createModemConfigurations(
    deviceInterfaces: any[],
    modemInterface: String,
    ssid?: any,
    ssidList?: any,
    type?: any,
    index?:any,
    acc?:any,
    isActiveInterface?:any,
    mode?:any,
    callPossible?:any,
    target?:any,
    existingValues:any={}
  ) {
    //if something is not being set correctly then please check "configurationSettings" in live page that is overwritting the values for default values.
    let allInterfaces = deviceInterfaces
      ? !deviceInterfaces.includes(modemInterface)
        ? [...deviceInterfaces, modemInterface]
        : deviceInterfaces
      : [modemInterface];
  console.log(existingValues, "oooooooooooooooo");
    if(target){
        console.log(target);
        switch (target) {
          case 'IPERF':
            const defaultValuesIPERF = {
              index,
              interface: modemInterface,
              deviceInterfaces: allInterfaces,
              allssids: ssidList || [],
               acc,
              start_after:0,
              isActiveInterface,
              mode,
              ...existingValues
            };
            ssid && (defaultValuesIPERF['wifiSSID'] = (defaultValuesIPERF['wifiSSID']||ssid));
            type && (defaultValuesIPERF['modem_type'] = type);
             return defaultValuesIPERF;


          case 'PINIPERF':

            const defaultValuesIPERFC= {
              index,
              interface: modemInterface,
              deviceInterfaces: allInterfaces,
              allssids: ssidList || [],
              acc,  
              isActiveInterface,
              mode,
              ...existingValues
            }
            ssid && (defaultValuesIPERFC['wifiSSID'] = (defaultValuesIPERFC['wifiSSID']||ssid));
            type && (defaultValuesIPERFC['modem_type'] = type);

            return defaultValuesIPERFC;


          case 'RF':

            const defaultValuesRF = {
              radio_continuous: true,
              serving_continuous: true,
              index,
              acc,
              start_after:0,
              isActiveInterface,mode,
              ...existingValues
            };
    
            ssid && (defaultValuesRF['wifiSSID'] = (defaultValuesRF['wifiSSID']||ssid));
            defaultValuesRF['interface'] = modemInterface;
            defaultValuesRF['deviceInterfaces'] = allInterfaces;
            defaultValuesRF['allssids'] = ssidList || []
            type && (defaultValuesRF['modem_type'] = type);
            return defaultValuesRF;
       
          case 'PINRF':

            const defaultValuesRFPIN = {
              radio_pindrop: true,
              serving_pindrop: true,
              index,
              acc,
              start_after:0,
              isActiveInterface,
              ...existingValues
            };
    
            ssid && (defaultValuesRFPIN['wifiSSID'] = (defaultValuesRFPIN['wifiSSID']||ssid));
            defaultValuesRFPIN['interface'] = modemInterface;
            defaultValuesRFPIN['deviceInterfaces'] = allInterfaces;
            defaultValuesRFPIN['allssids'] = ssidList || []
            type && (defaultValuesRFPIN['modem_type'] = type);
            return defaultValuesRFPIN;

            case 'PING':

              const defaultValuesPING={
                interface: modemInterface,
                deviceInterfaces: allInterfaces,
                allssids: ssidList || [],
                urlError:true,
                index,
                acc,
                start_after:0,
                isActiveInterface,
                mode,
                ...existingValues
              };
              ssid && (defaultValuesPING['wifiSSID'] = (defaultValuesPING['wifiSSID']||ssid));
              type && (defaultValuesPING['modem_type'] = type);

              return defaultValuesPING;

              case 'PINGCONTI':
                  const defaultValuesPINGCONTI= {
                  interface: modemInterface,
                  deviceInterfaces: allInterfaces,
                  allssids: ssidList || [],
                  urlError:true,
                  index,
                  acc,
                  isActiveInterface,
                  mode,
                  ...existingValues
                };
                ssid && (defaultValuesPINGCONTI['wifiSSID'] = (defaultValuesPINGCONTI['wifiSSID']||ssid));
                type && (defaultValuesPINGCONTI['modem_type'] = type);

                return defaultValuesPINGCONTI;
    
                case 'CURLCONTI':
    
                    const defaultValuesCURLCONTI = {
                          interface: modemInterface,
                          deviceInterfaces: allInterfaces,
                          allssids: ssidList || [],
                          urlError: true,
                          index,
                          acc,
                          isActiveInterface,
                          mode,
                          ...existingValues
                        };
                  ssid && (defaultValuesCURLCONTI['wifiSSID'] = (defaultValuesCURLCONTI['wifiSSID']||ssid));
                  type && (defaultValuesCURLCONTI['modem_type'] = type);

                  return defaultValuesCURLCONTI;
      
              case 'CURL':
    
                const defaultValuesCURL = {
                      interface: modemInterface,
                      deviceInterfaces: allInterfaces,
                      allssids: ssidList || [],
                      urlError: true,
                      index,
                      acc,
                      isActiveInterface,
                      mode,
                      ...existingValues
                    };
                ssid && (defaultValuesCURL['wifiSSID'] = (defaultValuesCURL['wifiSSID']||ssid));
                type && (defaultValuesCURL['modem_type'] = type);

                return defaultValuesCURL;
    
                case 'PINYOUTUBE':
     
                  const defaultValuesY = {
                        interface: modemInterface,
                        deviceInterfaces: allInterfaces,
                        allssids: ssidList || [],
                        urlError: true,
                        index,
                        acc,
                        isActiveInterface,
                        mode,
                        ...existingValues
                      };
                  ssid && (defaultValuesY['wifiSSID'] = (defaultValuesY['wifiSSID']||ssid));
                  type && (defaultValuesY['modem_type'] = type);

                  return defaultValuesY;

                case 'YOUTUBE':
 
                    if(acc!="yes"){
                      const defaultValuesYC = {
                          interface: modemInterface,
                          deviceInterfaces: allInterfaces,
                          allssids: ssidList || [],
                          urlError: true,
                          index,
                          acc,
                          isActiveInterface,
                          mode,
                          ...existingValues
                        };
                    ssid && (defaultValuesYC['wifiSSID'] = (defaultValuesYC['wifiSSID']||ssid));
                    type && (defaultValuesYC['modem_type'] = type);
                    return defaultValuesYC;}
                    else{
                      return null;
                    }

                case 'SPEED':
                      const defaultValuesS ={
                            interface: modemInterface,
                            deviceInterfaces: allInterfaces,
                            allssids: ssidList || [],
                            urlError: true,
                            index,
                            acc,
                            isActiveInterface,
                            mode,
                            ...existingValues
                          };
                      ssid && (defaultValuesS['wifiSSID'] = (defaultValuesS['wifiSSID']||ssid));
                      type && (defaultValuesS['modem_type'] = type);

                      return defaultValuesS;

                      case 'SPEEDCONTI':
                        const defaultValuesSC = {
                              interface: modemInterface,
                              deviceInterfaces: allInterfaces,
                              allssids: ssidList || [],
                              urlError: true,
                              index,
                              acc,
                              isActiveInterface,
                              mode,
                              ...existingValues
                            };
                        ssid && (defaultValuesSC['wifiSSID'] = (defaultValuesSC['wifiSSID']||ssid));
                        type && (defaultValuesSC['modem_type'] = type);
                        return defaultValuesSC;

                  case 'VIDEO':
                      const defaultValuesVideo = {
                            interface: modemInterface,
                            deviceInterfaces: allInterfaces,
                            allssids: ssidList || [],
                            urlError: true,
                            index,
                            acc,
                            ...existingValues
                          };
                      ssid && (defaultValuesVideo['wifiSSID'] = (defaultValuesVideo['wifiSSID']||ssid));
                      type && (defaultValuesVideo['modem_type'] = type);

                      return defaultValuesVideo;
            case 'CALL':
            if(callPossible){
            const defaultValuesCall = {
              index,mode,callPossible,...existingValues
            };
    
            ssid && (defaultValuesCall['wifiSSID'] = (defaultValuesCall['wifiSSID']||ssid));
            defaultValuesCall['interface'] = modemInterface;
            defaultValuesCall['deviceInterfaces'] = allInterfaces;
            defaultValuesCall['allssids'] = ssidList || []
            type && (defaultValuesCall['modem_type'] = type);
            return defaultValuesCall;
            }            
            return null;

            case 'CALLCONTI':
            if(callPossible){
            const defaultValuesCallConti = {
              index,mode,
              callPossible,...existingValues
            };
    
            ssid && (defaultValuesCallConti['wifiSSID'] = (defaultValuesCallConti['wifiSSID']||ssid));
            defaultValuesCallConti['interface'] = modemInterface;
            defaultValuesCallConti['deviceInterfaces'] = allInterfaces;
            defaultValuesCallConti['allssids'] = ssidList || []
            type && (defaultValuesCallConti['modem_type'] = type);
            return defaultValuesCallConti;
            }            
            return null;
            
          case 'RRC':
            const defaultValuesRRC = {
                                      index,mode,...existingValues
                                    };
    
            ssid && (defaultValuesRRC['wifiSSID'] = (defaultValuesRRC['wifiSSID']||ssid));
            defaultValuesRRC['interface'] = modemInterface;
            defaultValuesRRC['deviceInterfaces'] = allInterfaces;
            defaultValuesRRC['allssids'] = ssidList || []
            type && (defaultValuesRRC['modem_type'] = type);

            return defaultValuesRRC;

          case 'RRCCONTI':
            const defaultValuesRRCConti = {
                                            index,mode,...existingValues
                                          };
            ssid && (defaultValuesRRCConti['wifiSSID'] = (defaultValuesRRCConti['wifiSSID']||ssid));
            defaultValuesRRCConti['interface'] = modemInterface;
            defaultValuesRRCConti['deviceInterfaces'] = allInterfaces;
            defaultValuesRRCConti['allssids'] = ssidList || []
            type && (defaultValuesRRCConti['modem_type'] = type);
            return defaultValuesRRCConti;

          case 'GNSS':
              const defaultValuesGNSS = {
                                        index,mode,...existingValues
                                      };
      
              ssid && (defaultValuesGNSS['wifiSSID'] = (defaultValuesGNSS['wifiSSID']||ssid));
              defaultValuesGNSS['interface'] = modemInterface;
              defaultValuesGNSS['deviceInterfaces'] = allInterfaces;
              defaultValuesGNSS['allssids'] = ssidList || []
              type && (defaultValuesGNSS['modem_type'] = type);
              return defaultValuesGNSS;

          case 'GNSSCONTI':
                  const defaultValuesGNSSConti = {
                                            index,mode,...existingValues
                                          };
                  ssid && (defaultValuesGNSSConti['wifiSSID'] = (defaultValuesGNSSConti['wifiSSID']||ssid));
                  defaultValuesGNSSConti['interface'] = modemInterface;
                  defaultValuesGNSSConti['deviceInterfaces'] = allInterfaces;
                  defaultValuesGNSSConti['allssids'] = ssidList || []
                  type && (defaultValuesGNSSConti['modem_type'] = type);
                return defaultValuesGNSSConti;
              default:
                return null
                // delete this.modemAndParametersMapping?.[id];
                // delete this.resetMapping?.[id];
            }
      
  }

  }

  encryptUsingAES256(val: any) {
    let A = CryptoJS.enc.Utf8.parse(this.A);
    var iv = CryptoJS.enc.Utf8.parse(this.B);
    // console.log(this.A, iv);
    var encrypted = CryptoJS.AES.encrypt(val, A, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }).ciphertext.toString(CryptoJS.enc.Base64);
    // encrypted =encrypted.toString();
    return encrypted;
  }

  getMaps(mapid?: any) {
    const filter: any = { sort: { mapname: 'asc' } };
    if (mapid) {
      filter.query = {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${mapid}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      };
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/maplist/_search?pretty&size=1000`,
      filter
    );
  }

  getReportMaplist(daterange: any) {
    let start = daterange?.startDate;
    let end = daterange?.endDate;
    return this.httpClient.get(
      `${this.apiEndPoint}/_/2.0/walktestmaps?starttime=${start}&endtime=${end}`
    );
  }

  addDummyMap(filter: any) {
    return this.httpClient.post(
      this.apiEndPoint + '/gwdevice/maplist/_create?_id=dummymap',
      filter
    );
  }

  getReportMaplistBase(daterange: any) {
    let start = daterange?.startDate;
    let end = daterange?.endDate;
    return this.httpClient.get(
      `${this.apiEndPoint}/_/2.0/walktestmaps?starttime=${start}&endtime=${end}&device_type=base`
    );
  }

  downloadMap(file: string) {
    return this.httpClient.get(`${this.fileServerUrl}/${file}`);
  }

  getVideosList() {
    console.log('called..........');
    return this.httpClient.get(`${this.fileServerUrl}/videos/files`);
  }

  getMapList() {
    return this.httpClient.get(`${this.fileServerUrl}/files`);
  }

  getMapListReports() {
    return this.httpClient.get(`${this.fileServerUrl}/reportsFiles`);
  }

  getTestCurrentStatus(ruleids: string) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: ruleids,
                type: 'phrase',
                fields: ['rule_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?pretty&size=10`,
      filter
    );
  }

  getTestsCurrentStatus(locname: string) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: locname,
                type: 'phrase',
                fields: ['locname'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?pretty&size=10`,
      filter
    );
  }

  getAllRunningTests() {
    const filter = {
      query: {
        bool: {
          should: [
            {
              bool: {
                must: [
                  {
                    query_string: {
                      query: '(continuous) OR (iperf_continuous)',
                      type: 'phrase',
                      fields: ['walktesttype', 'test_duration'],
                    },
                  },
                  {
                    query_string: {
                      query: '(Applied) OR (In Progress) OR (Queued)',
                      type: 'phrase',
                      fields: ['status.keyword'],
                    },
                  },
                ],
                must_not: [],
              },
            },
          ],
        },
      },
      sort: {
        '_kuzzle_info.createdAt': 'desc',
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktest/_search?size=1000`,
      filter
    );
  }

  deleteRoute(id: string) {
    return this.httpClient.delete(
      `${this.apiEndPoint}/gwdevice/walktestroute/${id}`
    );
  }

  createRoute(
    location: { x_coord: number; y_coord: number },
    mapname: string,
    mapid: string,
    ts: number,
    locname: string,
    walktesttype: string,
    dimension: { width: number; height: number }
  ) {
    const filter = {
      locname: locname,
      mapname: mapname,
      mapid: mapid,
      walktesttype: walktesttype,
      location: location,
      ts: ts,
      width: dimension?.width,
      height: dimension?.height,
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestroute/_create`,
      filter
    );
  }

  createPinDropEvent(
    location: { x_coord: number; y_coord: number },
    ts: number,
    locname: string,
    deviceid: string,
    text: string
  ) {
    const filter = {
      locname: locname,
      location: location,
      ts: ts,
      stop_ts: ts,
      log_text: text,
      deviceid: deviceid,
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/eventlog/_create`,
      filter
    );
  }

  locateUntracedPoints(
    first: { x: number; y: number; ts: number; floor?: string },
    ts: any,
    notification: any
  ) {
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    console.log(colors);
    Object.assign(notification, {
      id: notification?._id,
      coordinate: { x: first?.x, y: first?.y },
      degree: 0,
      floor: undefined,
      colors,
      parametrs,
      values: parametrs,
    });
    return notification;
  }

  locatePoint(
    first: { x: number; y: number; ts: number; floor?: string },
    second: { x: number; y: number; ts: number; floor?: string },
    ts: number,
    notification: any
  ) {
    notification?._id == '11oyYIoBOkCuU1Z7sQoO' &&
      console.log(first, second, ts, notification);
    let original = notification;
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    //  (notification?._source?.ui_testtype=="3_min"||notification?._source?.ui_testtype=="continuous"||notification?._source?.ui_testtype=="iperf"||notification?._source?.ui_testtype=="iperf_continuous") ? { rssi: '#808080' }:
    // (notification?._source?.ui_testtype=="ytube"||notification?._source?.ui_testtype=="ytube")
    // { rssi: '#808080' }
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    // console.log(colors);
    let degree = 0;
    if (first?.ts) {
      if (ts <= first?.ts && ts >= second?.ts) {
        // console.log(ts, 'first')
        let slop = (first?.y - second?.y) / (first?.x - second?.x);
        let radAngle = Math.atan(slop);
        degree = (180 * radAngle) / Math.PI;
        let percent = (ts - second?.ts) / (first?.ts - second?.ts);
        let coordinate = {
          x: second?.x + (first?.x - second?.x) * percent,
          y: second?.y + (first?.y - second?.y) * percent,
        };
        let floor = first?.floor;
        let routePoint = first?.ts + '-';
        let values = parametrs;
        return {
          ...notification,
          id: notification?._id,
          coordinate,
          degree,
          floor,
          routePoint,
          colors,
          values,
        };
      } else if (ts > first?.ts) {
        // console.log(ts, 'second')
        let floor = first?.floor;
        let values = parametrs;
        return {
          ...notification,
          id: notification?._id,
          coordinate: { x: first?.x, y: first?.y },
          degree: 0,
          floor: floor,
          routePoint: first?.ts,
          colors,
          values,
        };
      }
    } else {
      // console.log(ts, 'third')
      let floor = second?.floor;
      let values = parametrs;
      return {
        ...notification,
        id: notification?._id,
        coordinate: { x: second?.x, y: second?.y },
        degree: 0,
        floor: floor,
        routePoint: second?.ts,
        colors,
        values,
      };
    }
  }

  locateSinglescane(notification: any, another_location?: any) {
    // console.log("locating the points");
    let parametrs = notification?._source?.reportfilter;
    let location = another_location || notification?._source?.location;
    const colors = { rssi: '#808080' };

    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    // console.log(colors);
    if (another_location?.lat) {
      notification._source.location = another_location;
    }
    Object.assign(notification, {
      id: notification?._id,
      coordinate: { x: location?.x_coord, y: location?.y_coord },
      degree: 0,
      floor: undefined,
      colors,
      parametrs,
      values: parametrs,
    });
    // console.log(notification?._source?.rule_result?.[0]?.walk_test?.location?.lat, notification?._source?.rule_result?.[0]?.walk_test?.location?.lng)
    return notification;
  }

  createObserverFunctionality() {
    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry: any) => {
          const intersecting = entry.isIntersecting;
          // console.log(entry)
          entry.target.style.visibility = intersecting ? 'visible' : 'hidden';
        });
      },
      { threshold: 0.3 }
    );

    return observer;
  }

  locateAtLatestPoint(
    lastPoint: { x: number; y: number; ts: number; floor?: string },
    notification: any
  ) {
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]);
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    let floor = lastPoint?.floor;
    let values = parametrs;
    return {
      ...notification,
      coordinate: { x: lastPoint?.x, y: lastPoint?.y },
      degree: 0,
      floor: floor,
      routePoint: lastPoint?.ts,
      colors,
      values,
    };
  }

  locatePindropTestPoint(
    notification: any,
    locationMap: {},
    count_num: number
  ) {
    // console.log(locationMap)
    let parametrs = notification?._source?.reportfilter;
    const colors = { rssi: '#808080' };
    parametrs
      ? Object.keys(parametrs).map((each: any) => {
          if (each) {
            if (each == 'lat') {
              //assuming only GNSS test will have lat in report_filter if not then we need to add another check to add test type
              colors['GPS'] = this.setColor('GPS', parametrs?.[each]); //second parameter is redundent for GPS
            } else {
              colors[each] = this.setColor(each, parametrs?.[each]);
            }
          }
        })
      : {};
    let values = parametrs;
    return {
      ...notification,
      coordinate: locationMap?.[notification?._source?.rule_id],
      degree: 0,
      colors,
      values,
      count_no: count_num,
    };
  }

  getCurrentKuzzleTime() {
    return this.httpClient.get(`${this.apiEndPoint}/_now`);
  }

  getSurveyResult(notificationid) {
    const filter = {
      filter: [
        { type: 'single', field: 'notificationid', value: [notificationid] },
      ],
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/_/walktestsurveydata`,
      filter
    );
  }

  getCompleteWalktestSurveyData(
    locname: string,
    dateRange?: any,
    subscription?: any
  ) {
    // console.log("surveydata called  ");
    return new Promise((resolve: any, reject): any => {
      const filter: any = {
        filter: [{ type: 'single', field: 'locname', value: [locname] }],
      };
      dateRange?.[0] &&
        dateRange?.[1] &&
        filter['filter'].push({
          type: 'range',
          field: 'starttime',
          value: { min: dateRange?.[0], max: dateRange?.[1] },
        });
      let survey$ = this.httpClient
        .post(`${this.apiEndPoint}/_/walktestsurveydata`, filter)
        .subscribe((response) => {
          resolve(response);
        });
      subscription && subscription.push(survey$);
    });
  }

  getNotification(
    imei: number,
    start_ts: number,
    stop_ts: number,
    ruleid?: number,
    notiid?: number
  ) {
    let imei_m = `\"${imei}\"`;
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: { query: imei_m, type: 'phrase', fields: ['imei'] },
            },
            {
              query_string: {
                query: start_ts,
                type: 'phrase',
                fields: ['rule_result.walk_test.start_TS'],
              },
            },
            {
              query_string: {
                query: stop_ts,
                type: 'phrase',
                fields: ['rule_result.walk_test.stop_TS'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    if (ruleid) {
      filter.query.bool.must.push({
        query_string: { query: ruleid, type: 'phrase', fields: ['rule_id'] },
      });
    }
    if (notiid) {
      filter.query.bool.must.push({
        query_string: { query: notiid, type: 'phrase', fields: ['_id'] },
      });
    }

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestnotification/_search?size=1`,
      filter
    );
  }

  getNotificationFromId(notiid?: number) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: { query: notiid, type: 'phrase', fields: ['_id'] },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestnotification/_search?size=1`,
      filter
    );
  }

  getGroupDetails(deviceid: any) {
    const match = [];
    if (deviceid) {
      match.push({ match: { 'devices.deviceid': deviceid } });
    }
    // deviceData?.modemData&&deviceData?.modemData.map(each=>{
    //      match.push({ "match": { "devices.imei": each?.IMEI }})
    // })
    const filter = {
      query: {
        nested: {
          path: 'devices',
          query: {
            bool: {
              must: match,
            },
          },
        },
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicegroup/_search?size=10`,
      filter
    );
  }

  getNotificationCount(
    deviceid: any,
    mapid: any,
    starttime: any,
    endtime: any,
    includebase?: any,
    base?: any
  ) {
    const filter = { query: { bool: { must: [] } } };
    filter.query.bool.must.push({
      range: {
        'rule_result.walk_test.stop_TS': { gte: starttime, lte: endtime },
      },
    });
    if (deviceid) {
      filter.query.bool.must.push({
        query_string: { query: deviceid, type: 'phrase', fields: ['deviceid'] },
      });
    }
    if (mapid) {
      filter.query.bool.must.push({
        query_string: {
          query: `\"${mapid}\"`,
          type: 'phrase',
          fields: ['mapid'],
        },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestnotification/_count`,
      filter
    );
  }

  getDeviceTableData(id: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${id}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/edgedevicemaster_slice/_search?size=1`,
      filter
    );
  }

  updateSliceData(id: any, key: any, value: any) {
    const filter = { [key]: value };
    //console.log(filter, id);
    return this.httpClient.put(
      `${this.apiEndPoint}/gwdevice/edgedevicemaster_slice/${id}/_update`,
      filter
    );
  }

  getHelperTableData(id: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${id}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/edgedevice_helper/_search?size=1`,
      filter
    );
  }

  getDeviceTableDataFromPlatform(id: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${id}\"`,
                type: 'phrase',
                fields: [
                  'xedge_platform.firmware_versions.PlatformSerialNumber',
                ],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/edgedevicemaster_slice/_search?size=1`,
      filter
    );
  }

  getDivecesList(mapName: any, daterange?: any) {
    // console.log(mapName[0]?.mapid)
    let api = `${this.apiEndPoint}/_/2.0/walktestdevices?mapid=${mapName[0]?.mapid}`;
    if (daterange?.startDate && daterange?.endDate) {
      api = `${api}&starttime=${daterange?.startDate}&endtime=${daterange?.endDate}`;
    }
    return this.httpClient.get(api);
  }

  getDivecesBase(mapName: any, daterange?: any) {
    // console.log(mapName[0]?.mapid)
    let api = `${this.apiEndPoint}/_/2.0/walktestdevices?mapid=${mapName[0]?.mapid}`;
    if (daterange?.startDate && daterange?.endDate) {
      api = `${api}&starttime=${daterange?.startDate}&endtime=${daterange?.endDate}&device_type=base`;
    }
    return this.httpClient.get(api);
  }

  fetchCompleteEventLogs(
    locname?: string,
    ruleid?: string,
    deviceid?: any,
    imei?: number,
    start?: number,
    end?: number,
    data = { result: [] },
    subscription?: any,
    size?: any,
    order?: any
  ) {
    // console.log("eventlog called  ", data);
    return new Promise((resolve, reject) => {
      // return new Promise((resolve, reject)=>{
      const bodyFilter = {};
      const finalResult = data;
      start && (bodyFilter['starttime'] = start);
      end && (bodyFilter['endtime'] = end);
      ruleid && (bodyFilter['ruleid'] = ruleid);
      locname && (bodyFilter['locname'] = locname);
      deviceid && (bodyFilter['deviceid'] = deviceid);
      imei && (bodyFilter['imei'] = imei);
      size && (bodyFilter['size'] = size);
      order && (bodyFilter['sort'] = order);
      let eventlog$ = this.httpClient
        .post(`${this.apiEndPoint}/_/2.0/eventlogdata`, bodyFilter)
        .subscribe((res: any) => {
          if (res?.result?.data) {
            finalResult['result'].push(res?.result?.data);
          }
          let len = 0;
          if (finalResult.result) {
            finalResult.result.map((each) => {
              if (each) {
                len += each.length;
              }
            });
          }
          console.log(
            finalResult.result.length,
            len,
            res?.result?.status,
            res?.result?.status == 'incomplete' && (size ? len <= 40000 : true)
          );
          if (
            res?.result?.status == 'incomplete' &&
            (size ? len <= 30000 : true)
          ) {
            this.fetchCompleteEventLogs(
              locname,
              ruleid,
              deviceid,
              imei,
              res?.result?.starttime,
              end,
              finalResult,
              subscription,
              size
            ).then((response) => {
              resolve(response);
            });
          } else {
            resolve({ result: { hits: finalResult?.result.flat() } });
          }
        });
      subscription && subscription.push(eventlog$);
    });
  }

  getMapDataFromId(id: any) {
    return this.httpClient.get(`${this.apiEndPoint}/gwdevice/maplist/${id}`);
  }

  rejectMessageInterpreter(msg: string = '', modem: any) {
    return msg.includes('3_min') && msg.includes('running')
      ? `RF test is running on Modem ${modem}`
      : msg.includes('iperf') && msg.includes('running')
      ? `IPERF test is running on Modem ${modem}`
      : msg.includes('conti') && msg.includes('running')
      ? `Continuous test is running on Modem ${modem}`
      : msg.includes('Bandlock')
      ? `Band lock is being configured on Modem ${modem}`
      : msg.includes('swupgrade')
      ? `Modem ${modem} software is being updated`
      : msg.includes('wificonfig')
      ? `WiFi Configuration is in progress`
      : msg.includes('apnconfig')
      ? `APN is being configured on Modem ${modem}`
      : msg.includes('3atcmd_dbg')
      ? `Debugging is in progress on Modem ${modem}`
      : msg.includes('cmdline_dbg')
      ? `Debugging is in progress on Modem ${modem}`
      : msg.includes('reboot')
      ? `Reboot is in progress on Modem ${modem}`
      : msg.includes('tele_freq')
      ? `Telemetry is being configured on Modem ${modem}`
      : msg.includes('WalkTest test running with ID')
      ? `Walktest is running in modem ${modem}`
      : msg;
  }

  walktestReportData(data) {
    return this.httpClient.post(
      this.apiEndPoint + '/_/walktestreportdata',
      data
    );
  }
  checkModemStatus(devices = []) {
    const filter = {
      type: 'walktest',
      devices: devices,
    };
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/assetgroup`, filter);
  }

  checkModemStatusBase(devices = [], interfaces = []) {
    const filter = {
      type: 'walktest',
      devices: devices,
      device_type: 'base',
      wifi_interface: interfaces,
    };
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/assetgroup`, filter);
  }

  saveSession(
    mapname: any,
    mapid: any,
    ruleid: any,
    imei: any,
    deviceid: any,
    device_type?: any
  ) {
    const filter = {
      ruleid: ruleid,
      mapname: mapname,
      mapid: mapid,
      imei: imei,
      deviceid: deviceid,
      status: 'Applied',
    };
    if (device_type) {
      filter['device_type'] = device_type;
    }
    // console.log(JSON.stringify(filter));
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/savesession`,
      filter
    );
  }

  walktestFilterData(
    time?: any,
    deviceid?: any,
    floorid?: any,
    imei?: any,
    result = {},
    subsctiption?: any
  ) {
    return new Promise((resolve: any, reject: any) => {
      const output = { ...result };
      const structure = {};
      time?.[0] && (structure['starttime'] = time?.[0]);
      time?.[1] && (structure['endtime'] = time?.[1]);
      imei && (structure['imei'] = imei);
      deviceid && (structure['deviceid'] = deviceid);
      floorid && (structure['mapid'] = floorid);
      // console.log(structure)
      // return new Promise((resolve, reject)=>{
      let report$ = this.httpClient
        .post(`${this.apiEndPoint}/_/walktestreport`, structure)
        .subscribe((res: any) => {
          console.log(res);
          const newObject = {};
          if (res?.result) {
            for (let each in res?.result) {
              if (!(each == 'starttime' || each == 'status')) {
                console.log(output?.[each], res?.result?.[each]);
                newObject[each] = [
                  ...(output?.[each]?.[0] != undefined ? output?.[each] : []),
                  ...(res?.result?.[each]?.[0] != undefined
                    ? res?.result?.[each]
                    : []),
                ];
              }
            }
          }
          // res?.result && Object.keys(res?.result).map(each => {
          //   if (!(each == "starttime" || each == 'status')) {
          //     output?.[each] ? newObject[each] = [...output?.[each], ...res?.result?.[each]] : newObject[each] = [...res?.result?.[each]]
          //   }
          // })
          // console.log(newObject, output)
          if (res?.result?.status == 'incomplete') {
            this.walktestFilterData(
              [res?.result?.starttime, time?.[1]],
              deviceid,
              floorid,
              imei,
              newObject,
              subsctiption
            ).then((response) => {
              resolve(response);
            });
          } else {
            // this.walktestFilterSubject.next(newObject)
            resolve(newObject);
          }
        });
      subsctiption && subsctiption.push(report$);
      // })
    });
  }

  fetchWalktestreportdata(
    time: any,
    mapid: any,
    deviceid: any,
    data = { result: [] },
    subscription?: any,
    baseId?: any
  ) {
    // console.log("reportdata called  ", data);
    return new Promise((resolve: any, reject: any) => {
      let devices = [];
      if (deviceid) {
        devices.push(deviceid);
      }
      if (baseId) {
        devices.push(baseId);
      }
      const bodyFilter: any = {
        filter: [
          {
            type: 'range',
            field: 'starttime',
            value: {
              min: time?.[0],
              max: time?.[1],
            },
          },
        ],
      };

      mapid &&
        bodyFilter?.filter.push({
          type: 'single',
          field: 'mapid',
          value: [mapid],
        });

      devices.length > 0 &&
        bodyFilter?.filter.push({
          type: 'single',
          field: 'deviceid',
          value: devices,
        });

      // console.log(JSON.stringify(bodyFilter))
      let report$ = this.httpClient
        .post(`${this.apiEndPoint}/_/walktestreportdata`, bodyFilter)
        .subscribe((res: any) => {
          const finalResult = data;
          // console.log(res)
          if (res?.result?.data) {
            // finalResult['result'].push(...data?.result);
            finalResult['result'].push(res?.result?.data);
          }
          // else {
          //   finalResult['result'].push(...data?.result);
          // }
          // finalResult['result'] = res?.result?.data?[...data?.result, ...res?.result?.data]:data?.result
          if (res?.result?.status == 'incomplete') {
            // console.log(finalResult, "incomplete");
            let lastInd = res?.result?.data ? res?.result?.data.length - 1 : 0;
            let lastData = res?.result?.data?.[lastInd];
            let time_lastNotification = lastData?._source?.ts + 1;
            this.fetchWalktestreportdata(
              [time_lastNotification, time?.[1]],
              mapid,
              deviceid,
              finalResult,
              undefined,
              baseId
            ).then((response) => {
              resolve(response);
            });
          } else {
            // console.log(finalResult, "complete");
            resolve({ result: finalResult?.result.flat() });
          }
        });
      subscription && subscription.push(report$);
      // return this.walktestReportDataSubject.pipe(first())
    });
  }

  getDropdownOptions() {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: 'dropdown_options',
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/configparam/_search?size=1`,
      filter
    );
  }

  fetchPCIs(rule = [], time) {
    const filterObject = { filter: [] };
    rule &&
      filterObject?.['filter'].push({
        field: 'rule_id',
        type: 'single',
        value: rule,
      });
    time?.[0] &&
      time?.[1] &&
      filterObject?.['filter'].push({
        field: 'starttime',
        type: 'range',
        value: {
          min: time?.[0],
          max: time?.[1],
        },
      });
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/pcinotificationreport`,
      filterObject
    );
  }
  fetchSurveyPCIs(rule = [], time: any) {
    const filterObject = { filter: [] };
    rule &&
      filterObject?.['filter'].push({
        field: 'rule_id',
        type: 'single',
        value: rule,
      });
    time?.[0] &&
      time?.[1] &&
      filterObject?.['filter'].push({
        field: 'starttime',
        type: 'range',
        value: {
          min: time?.[0],
          max: time?.[1],
        },
      });
    return this.httpClient.post(
      `${this.apiEndPoint}/_/2.0/pcireport`,
      filterObject
    );
  }

  fetchRoute(locname: string) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: locname,
                type: 'phrase',
                fields: ['locname'],
              },
            },
          ],
        },
      },
      sort: { ts: 'desc' },
    };

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/walktestroute/_search?size=10000`,
      filter
    );
  }
  getDetailedReportPageData(rule: string, locname: string) {
    return this.httpClient.post(`${this.fileServerUrl}/htmlfile`, {
      rule: rule,
      locname: locname,
    });
  }

  triggerExtrapolation(locname: any) {
    return this.httpClient.post(`${this.apiEndPoint}/_/extrapolatelocation`, {
      locname: locname,
    });
  }

  generateDetailedReport(filter: any) {
    return this.httpClient.post(`${this.fileServerUrl}/htmlfile`, filter);
  }

  detailedReportData(user: any, authorization?: any) {
    const filter = {
      query: {
        bool: {
          must: [],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    if (authorization != 'admin' && authorization != 'super admin') {
      filter.query.bool.must.push({
        query_string: { query: user, type: 'phrase', fields: ['user'] },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/detailedreportdata/_search?size=1000`,
      filter
    );
  }

  downloadFile(file: any) {
    return this.httpClient.get(`${this.fileServerUrl}/${file}`, {
      responseType: 'blob',
    });
  }

  downloadFileInFolder(folder: any, file: any) {
    return this.httpClient.get(
      `${this.fileServerUrl}/custom/${folder}/${file}`,
      { responseType: 'blob' }
    );
  }

  scheduleTest(locname, payload) {
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_create?_id=${locname}`,
      payload
    );
  }

  scheduleTestBulk(payloads = {}) {
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_mCreate`,
      payloads
    );
  }

  getScheduledTest(locname) {
    return this.httpClient.get(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/${locname}`
    );
  }

  getScheduledTestForSeries(series: any) {
    const payload = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: series,
                type: 'phrase',
                fields: ['series_id'],
              },
            },
          ],
          must_not: {
            exists: {
              field: 'status',
            },
          },
        },
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=10000`,
      payload
    );
  }

  cancelScheduledTest(locname) {
    return this.httpClient.delete(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/${locname}`
    );
  }

  getTestStatus(locname: any) {
    return this.httpClient.get(
      `${this.apiEndPoint}/_/2.0/scheduled_walktest_status?locname=${locname}`
    );
  }

  createIperfMonitorRecord(ruleid: any, device: any, imei: any) {
    const payload = {
      imei: imei,
      deviceid: device,
      rule_id: ruleid,
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/iperftest_monitor/_create?_id=${ruleid}`,
      payload
    );
  }

  getDeviceLocation(serialnumber: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `\"${serialnumber}\"`,
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicestaticlocation/_search?size=100`,
      filter
    );
  }

  getScheduledTests(
    id?: any,
    latest?: boolean,
    locname?: any,
    daterange?: any
  ) {
    const filter = {
      query: { bool: { must: [] } },
      sort: { starttime: 'desc' },
    };

    if (id) {
      filter.query.bool.must.push({
        query_string: {
          query: id,
          type: 'phrase',
          fields: ['payload.devices.deviceid'],
        },
      });
    }
    if (latest) {
      // filter.query.bool.must.push({range:{endtime:{gte:new Date().valueOf(), lte:new Date().valueOf()+3600*1000*24*365}}});
    }

    if (daterange?.start) {
      console.log(daterange?.start, '  , ', daterange?.end);
      filter.query.bool.must.push({
        range: { endtime: { lte: daterange?.end } },
      });
      filter.query.bool.must.push({
        range: { starttime: { gte: daterange?.start } },
      });
    }
    if (locname) {
      filter.query.bool.must.push({
        query_string: { query: locname, type: 'phrase', fields: ['_id'] },
      });
    }

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=10000`,
      filter
    );
  }

  getScheduledTestsForConflict(
    id?: any,
    latest?: boolean,
    locname?: any,
    daterange?: any
  ) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: id,
                type: 'phrase',
                fields: ['payload.devices.deviceid'],
              },
            },
            { bool: { should: [] } },
          ],
        },
      },
      sort: { starttime: 'asc' },
    };

    if (daterange?.start) {
      console.log(daterange?.start, '  , ', daterange?.end);
      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 1: starttime within range (endtime can be anything)
        range: {
          starttime: {
            gte: daterange?.start,
            lte: daterange?.end,
          },
        },
      });
      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 2: both starttime and endtime within range
        bool: {
          must: [
            {
              range: {
                starttime: {
                  gte: daterange?.start,
                  lte: daterange?.end,
                },
              },
            },
            {
              range: {
                endtime: {
                  gte: daterange?.start,
                  lte: daterange?.end,
                },
              },
            },
          ],
        },
      });

      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 3: starttime before range but endtime within range
        bool: {
          must: [
            {
              range: {
                starttime: {
                  lt: daterange?.start,
                },
              },
            },
            {
              range: {
                endtime: {
                  gte: daterange?.start,
                  lte: daterange?.end,
                },
              },
            },
          ],
        },
      });
      filter.query.bool.must?.[1]?.bool?.should.push({
        // Scenario 4: starttime before range start and endtime after range end
        bool: {
          must: [
            {
              range: {
                starttime: {
                  lt: daterange?.start,
                },
              },
            },
            {
              range: {
                endtime: {
                  gt: daterange?.end,
                },
              },
            },
          ],
        },
      });
    }

    if (locname) {
      filter.query.bool.must?.[1]?.bool?.should.push({
        query_string: { query: locname, type: 'phrase', fields: ['_id'] },
      });
    }

    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/_search?size=10000`,
      filter
    );
  }

  updateWalktestTable(id: any, payload: any) {
    return this.httpClient.patch(
      `${this.apiEndPoint}/gwdevice/devicereq/${id}/_update`,
      payload
    );
  }

  createSchedulerEntry(payload: any) {
    return this.httpClient.post(
      `${this.fileServerUrl}/schedule_tests`,
      payload
    );
  }

  getAllTests(locname: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: locname,
                type: 'phrase',
                fields: ['locname'],
              },
            },
            {
              query_string: {
                query: 'WalkTest',
                type: 'phrase',
                fields: ['rule'],
              },
            },
          ],
        },
      },
      sort: {
        '_kuzzle_info.createdAt': 'desc',
      },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?size=1000`,
      filter
    );
  }

  updateScheduleTests(locname: any, data: any) {
    return this.httpClient.patch(
      `${this.apiEndPoint}/gwdevice/scheduled_walktest/${locname}/_update`,
      data
    );
  }

  getIperfServers(servertype?: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: servertype || 'iperf_server',
                type: 'phrase',
                fields: ['_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/configparam/_search?size=1`,
      filter
    );
  }

  pingServer(server: string) {
    return this.httpClient.get(`${this.fileServerUrl}/ping/${server}`);
  }

  getMapFile(file: string) {
    return this.httpClient.get(`${this.fileServerUrl}/${file}`, {
      responseType: 'blob',
    });
  }

  getMapFileInFolder(folder: any, file: string) {
    return this.httpClient.get(
      `${this.fileServerUrl}/custom/${folder}/${file}`,
      {
        responseType: 'blob',
      }
    );
  }

  iperfStatus(
    server: any,
    port: any,
    command: any,
    param1?: any,
    param2?: any,
    toeknid?: any
  ) {
    if (param1 && param2) {
      const filter = {
        server: server,
        iperf_server_param1: param1,
        iperf_server_param2: param2,
        command: command,
        port: port,
      };
      if (command == 'stop') {
        filter['test_id'] = toeknid;
      }
      return this.httpClient.post(
        `${this.containerapiEndPoint}/stop_start_iperfserver`,
        filter
      );
    } else {
      if (command == 'start') {
        return this.pingServer(server);
      }
    }
  }

  streamServers(filter: any) {
    return this.httpClient.post(
      `${this.containerapiEndPoint}/stop_start_iperfserver`,
      filter
    );
  }

  getWorkingIperfServer(filter: any) {
    return this.httpClient.post(
      `${this.containerapiEndPoint}/stop_start_iperfserver`,
      filter
    );
  }

  decryptUsingAES256(encrypted: any) {
    let _key = CryptoJS.enc.Utf8.parse('frgrtyhyujhogdrt');
    let _iv = CryptoJS.enc.Utf8.parse('frgrtyhyujhogdrt');

    let decrypted = CryptoJS.AES.decrypt(encrypted, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }

  stopAllTests(deviceid: string) {
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/edgecmdstop`, {
      device: deviceid,
    });
  }

  stopOneTest(ruleid: string, tokenid?: any) {
    return this.httpClient
      .post(`${this.apiEndPoint}/_/2.0/edgecmdstop`, { ruleids: [ruleid] })
      .pipe(
        mergeMap((res: any) => {
          // console.log(res, "nothing......");
          return this.getTestCurrentStatus(ruleid);
        })
      )
      .pipe(
        mergeMap((res: any) => {
          // console.log(res, "devicereq data......");
          if (res?.result?.hits?.[0]?._source?.condition?.port) {
            let teatid = res?.result?.hits?.[0]?._source?.test_id || tokenid;
            return this.createIpertServerMapAnfStop(
              ruleid,
              res?.result?.hits?.[0],
              teatid
            );
          }
          return of({});
        })
      );
  }

  createIpertServerMapAnfStop(ruleid: any, data: any, token_id?: any) {
    return this.getIperfServers()
      .pipe(
        map((res: any) => {
          let servers = res?.result?.hits?.[0]?._source?.iperf_servers;
          const map = {};
          servers &&
            servers.map((each) => {
              if (each?.ip) {
                map[`${each?.address}-${each?.ip}`] = each;
              }
              if (each?.ip6 && each?.ip6 != 'Not available') {
                map[`${each?.address}-${each?.ip6}`] = each;
              }
            });
          return map;
        })
      )
      .pipe(
        mergeMap((map: any) => {
          // console.log(map, "nothing......");
          return this.stopServer(ruleid, map, data, token_id);
        })
      );
  }

  stopAllTestWithRules(ruleid: any[] = []) {
    return this.httpClient.post(`${this.apiEndPoint}/_/2.0/edgecmdstop`, {
      ruleids: ruleid,
    });
  }

  stopServer(ruleid: string, credMap = {}, data?: any, tokenid?: any) {
    // console.log(ruleid, credMap, data, tokenid);
    if (data) {
      if (data?._source?.condition?.server || data?._source?.condition?.ip) {
        // console.log( credMap?.[`${data?._source?.condition?.server}-${data?._source?.condition?.ip}`]?.iperf_server_param1,credMap?.[`${data?._source?.condition?.server}-${data?._source?.condition?.ip}`]?.iperf_server_param2);
        return this.iperfStatus(
          data?._source?.condition?.server,
          data?._source?.condition?.port,
          'stop',
          credMap?.[
            `${data?._source?.condition?.server}-${data?._source?.condition?.ip}`
          ]?.iperf_server_param1,
          credMap?.[
            `${data?._source?.condition?.server}-${data?._source?.condition?.ip}`
          ]?.iperf_server_param2,
          tokenid
        );
      }
      return of({ data });
    } else {
      return this.getTestCurrentStatus(ruleid)
        .pipe(
          mergeMap((response: any) => {
            // console.log(response, "from devicereq");
            let data = response?.result?.hits?.[0];
            let test_id =
              response?.result?.hits?.[0]?._source?.test_id || tokenid;
            return of({
              server: data?._source?.condition?.server,
              port: data?._source?.condition?.port,
              ip: data?._source?.condition?.ip,
              test_id: test_id,
            });
          })
        )
        .pipe(
          mergeMap((res: any) => {
            // console.log(res, "from devicereq extracted");
            if (res?.server || res?.ip) {
              // console.log( credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param1,credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param2);
              return (
                credMap?.[`${res?.server}-${res?.ip}`]?.managed &&
                this.iperfStatus(
                  res?.server,
                  res?.port,
                  'stop',
                  credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param1,
                  credMap?.[`${res?.server}-${res?.ip}`]?.iperf_server_param2,
                  res?.test_id
                )
              );
            }
            return of({ res });
          })
        );
    }
  }

  getDeviceLocationOnMap(serialnumber?: any, mapid?: any) {
    const filter = {
      query: { bool: { must: [] } },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };

    if (serialnumber) {
      filter.query.bool.must.push({
        query_string: {
          query: `${serialnumber}`,
          type: 'phrase',
          fields: ['_id'],
        },
      });
    }
    if (mapid) {
      filter.query.bool.must.push({
        query_string: {
          query: `\"${mapid}\"`,
          type: 'phrase',
          fields: ['mapid'],
        },
      });
    }
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicestaticlocation/_search?size=100`,
      filter
    );
  }

  getDeviceLastLocation(serialnumber: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: serialnumber,
                type: 'phrase',
                fields: ['deviceid'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicelocation/_search?size=1`,
      filter
    );
  }

  getAllTestCurrentStatus(rule: string, arg: any[]) {
    const filter = {
      query: {
        bool: {
          must: [
            { query_string: { query: rule, type: 'phrase', fields: ['rule'] } },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    arg &&
      arg.map((each) => {
        if (each?.key && each?.value) {
          filter.query.bool.must.push({
            query_string: {
              query: each?.value,
              type: 'phrase',
              fields: [each?.key],
            },
          });
        }
      });
    // console.log(JSON.stringify(filter));
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/devicereq/_search?pretty&size=1`,
      filter
    );
  }

  getEventlogs(ruleid: any) {
    const filter = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: ruleid,
                type: 'phrase',
                fields: ['rule_id'],
              },
            },
          ],
        },
      },
      sort: { '_kuzzle_info.createdAt': 'desc' },
    };
    return this.httpClient.post(
      `${this.apiEndPoint}/gwdevice/eventlog/_search?pretty&size=10`,
      filter
    );
  }

  time_convertFormatted(totalmiliSeconds: number): string {
    let totalSeconds = totalmiliSeconds / 1000;
    if (totalSeconds < 1) {
      return totalmiliSeconds + ' ms';
    }
    const days = Math.floor(totalSeconds / 86400);
    const remainingSeconds = totalSeconds % 86400;
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = Math.floor(remainingSeconds % 60);

    const daysDisplay = days > 0 ? days + ' d ' : '';
    const hoursDisplay = hours > 0 ? hours + ' hr ' : '';
    const minutesDisplay = minutes > 0 ? minutes + ' min ' : '';
    const secondsDisplay = seconds > 0 ? seconds + ' sec' : '';

    return daysDisplay + hoursDisplay + minutesDisplay + secondsDisplay;
  }

  getEdgedevData(deviceId?: string, imei?: string) {
    let headers = new HttpHeaders();
    const payload = {
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: deviceId,
                type: 'phrase',
                fields: ['deviceid'],
              },
            },
            // { query_string: { query: imei, type: "phrase", fields: ["imei"] } },
          ],
        },
      },
      sort: [{ '_kuzzle_info.createdAt': 'desc' }],
    };
    return this.httpClient.post(
      this.apiEndPoint + '/gwdevice/edgedev/_search?size=1',
      payload,
      { headers }
    );
  }

  getDivecename() {
    return this.httpClient.get(this.apiEndPoint + '/_/2.0/devicelist');
  }

  colorsList = [
    '#305f90',
    '#a7df1f',
    '#1355cd',
    '#71f7bd',
    '#f3a70f',
    '#724f5f',
    '#01093a',
    '#3cb85d',
    '#513849',
    '#e8236d',
    '#34fdfe',
    '#966136',
    '#76d9cc',
    '#bca405',
    '#b0dbdf',
    '#49bf25',
    '#329b47',
    '#6fef26',
    '#f86c93',
    '#a19eb1',
    '#2a8201',
    '#d753b1',
    '#bc709f',
    '#e262be',
    '#e9c79a',
    '#e17962',
    '#bb8724',
    '#869b5a',
    '#0c8ba4',
    '#2947c6',
    '#febb00',
    '#8f84bf',
    '#78f0bc',
    '#cbc01f',
    '#47b4bb',
    '#25cb1c',
    '#8fdaac',
    '#5ea3fc',
    '#c5c732',
    '#740785',
    '#9164a8',
    '#e99c8e',
    '#5cdabf',
    '#246315',
    '#167365',
    '#2c1158',
    '#9fb4be',
    '#3f0c49',
    '#c54af3',
    '#4d8ec8',
    '#aee313',
    '#0ee8e2',
    '#5d659d',
    '#d29163',
    '#84a15c',
    '#939957',
    '#8e0d0a',
    '#582a32',
    '#003094',
    '#af5c51',
    '#a6bf57',
    '#b60f45',
    '#a9c331',
    '#85816f',
    '#e618a5',
    '#068955',
    '#480fd4',
    '#d167f7',
    '#0062ec',
    '#d201c0',
    '#628f84',
    '#54e0fe',
    '#2f02f6',
    '#6aa631',
    '#9db9e1',
    '#930ea1',
    '#47fab1',
    '#a961d3',
    '#f83c1d',
    '#e5e6f7',
    '#88f116',
    '#798784',
    '#b2b752',
    '#4a3936',
    '#54c1c1',
    '#d4b11f',
    '#553f68',
    '#2a6f34',
    '#c9f029',
    '#51aba8',
    '#f2960c',
    '#c72759',
    '#9217eb',
    '#963951',
    '#9c27c7',
    '#b0bbdd',
    '#a0bd13',
    '#b2e8f5',
    '#f8b7fc',
    '#7d4ef2',
  ];

  filterParamsMapping = {
    RF: [
      { value: 'rssi', name: 'RSSI', param: 'rssi', searchKey: 'rssi' },
      { value: 'rsrp', name: 'RSRP', param: 'rsrp', searchKey: 'rsrp' },
      { value: 'rsrq', name: 'RSRQ', param: 'rsrq', searchKey: 'rsrq' },
      { value: 'sinr', name: 'SINR', param: 'sinr', searchKey: 'sinr' },
    ],
    IPERF: [
      { value: 'rssi', name: 'RSSI', param: 'rssi', searchKey: 'rssi' },
      { value: 'rsrp', name: 'RSRP', param: 'rsrp', searchKey: 'rsrp' },
      { value: 'rsrq', name: 'RSRQ', param: 'rsrq', searchKey: 'rsrq' },
      { value: 'sinr', name: 'SINR', param: 'sinr', searchKey: 'sinr' },
      {
        value: 'tcp_ul',
        name: 'TCP UL',
        param: 'iperf_tcp_ul_throughput',
        searchKey: 'tcp_ul',
      },
      {
        value: 'tcp_dl',
        name: 'TCP DL',
        param: 'iperf_tcp_dl_throughput',
        searchKey: 'tcp_dl',
      },
      {
        value: 'udp_ul',
        name: 'UDP UL',
        param: 'iperf_udp_ul_throughput',
        searchKey: 'udp_ul',
      },
      {
        value: 'udp_dl',
        name: 'UDP DL',
        param: 'iperf_udp_dl_throughput',
        searchKey: 'udp_dl',
      },
      {
        value: 'ul_jitter',
        name: 'UL JITTER',
        param: 'iperf_udp_ul_jitter',
        searchKey: 'ul_jitter',
      },
      {
        value: 'dl_jitter',
        name: 'DL JITTER',
        param: 'iperf_udp_dl_jitter',
        searchKey: 'dl_jitter',
      },
    ],
    Youtube: [
      {
        value: 'average_download_speed_mbps',
        name: 'Average Download Speed',
        param: 'average_download_speed_mbps',
        searchKey: 'average_download_speed_mbps',
      },
      // { value: 'overall_quality_assessment', name: 'Overall Quality Assessment', param:"overall_quality_assessment", searchKey: 'overall_quality_assessment' },
      // { value: 'bytes_received_kb', name: 'Bytes Received', param: "bytes_received_kb", searchKey: 'bytes_received_kb' },
      // { value: 'bytes_sent_kb', name: 'Bytes Sent', param: "bytes_sent_kb", searchKey: 'bytes_sent_kb' },
      // { value: 'average_upload_speed_mbps', name: 'Average Upload Speed', param: "average_upload_speed_mbps", searchKey: 'average_upload_speed_mbps' },
      // { value: 'server_response_time', name: 'Server Response Time', param: "server_response_time", searchKey: 'server_response_time' }
    ],
    'Wget Curl': [
      // { value: 'connect_time', name: 'Connect Time', param: "connect_time", searchKey: 'connect_time' },
      {
        value: 'totaltime',
        name: 'Total Time',
        param: 'totaltime',
        searchKey: 'curltest_total_time',
      },
      // { value: 'starttransfer_time', name: 'Start Transfer Time', param: "starttransfer_time", searchKey: 'starttransfer_time' }
    ],
    'Speed Test': [
      {
        value: 'download',
        name: 'Download Speed',
        param: 'download',
        searchKey: 'speedtest_download',
      },
      {
        value: 'upload',
        name: 'Upload Speed',
        param: 'upload',
        searchKey: 'speedtest_upload',
      },
      // { value: 'jitter', name: 'Jitter', param: "jitter", searchKey: 'jitter' },
      // { value: 'ping', name: 'Ping', param: "ping", searchKey: 'ping' }
    ],
    'Ping Test': [
      {
        value: 'pkt_loss',
        name: 'Packet Loss',
        param: 'pkt_loss',
        searchKey: 'pkt_loss',
      },
      // { value: 'pkts_tx', name: 'Packets Transmitted', param:"pkts_tx", searchKey: 'pkts_tx' },
      // { value: 'pkts_rx', name: 'Packets Received', param:"pkts_rx", searchKey: 'pkts_rx' }
    ],
  };

  parameterWisiRnage = {
    pktsize: {
      min: 20,
      max: 65507,
      message: 'Packet Size should be between 20 and 65507',
    },
    pkt_count: {
      min: 1,
      max: 10,
      message: 'Packet Count should be between 1 and 10',
    },
    pktinterval: {
      min: 1,
      max: 30,
      message: 'Packet Interval should be between 1 and 30',
    },
    tcp_parallel_stream: {
      min: 1,
      max: 16,
      message: 'Value should be between 1 and 16',
    },
    udp_parallel_stream: {
      min: 1,
      max: 8,
      message: 'Value should be between 1 and 8',
    },
    dialfrequency: {
      Min: { min: 1, max: 60, message: 'Value should be between 1 and 60' },
      Sec: {
        min: 60,
        max: 3600,
        message: 'Value should be between 60 and 3600',
      },
      Hrs: { min: 1, max: 1, message: 'Allowed value is 1' },
    },
    waittime: {
      min: 15,
      max: 60,
      message: 'Wait Time should be between 15 and 60',
    },
    interval: {
      min: 1,
      max: 1000,
      message: 'Interval should be between 1 and 1000',
    },
     gnss_interval: {
      min: 1,
      max: 1000,
      message: 'Interval should be between 1 and 1000',
    },
    iteration_count:{
      min: 1,
      max: 100,
      message: 'Iteration Count should be between 1 and 100',
    },
    iteration_interval:{
      min: 5,
      max: 300,
      message: 'Iteration Interval should be between 5 and 300',
    }
  };


  getDeviceStatus(serialNo:any){
      return new Promise((resolve, reject)=>{
          if (serialNo) {
            this.checkModemStatus([serialNo])
            .subscribe((deviceStatusData: any) => {
              console.log(deviceStatusData);
              let deviceData = deviceStatusData?.result?.[serialNo];
              let deviceStatus =
                deviceData?.['online'] == 'Yes' &&
                deviceData?.['status'] == 'Eligible';
              let active_interface = deviceData?.active_interface;
              this.getDeviceTableData(serialNo).subscribe({next:(devicesData:any)=>{
               console.log(devicesData);
               if(devicesData?.result?.hits?.[0]){
                const modemNames =devicesData?.result?.hits?.[0]?._source?.modemNames;
                const modemDataLocal = {};
                const imeiModemMap = {};
                let platformNo = devicesData?.result?.hits?.[0]?._source?.xedge_platform?.firmware_versions?.PlatformSerialNumber;
                let allModems = devicesData?.result?.hits?.[0]?._source?.xedge_slice?.modem||[];
                let deviceacc = devicesData?.result?.hits?.[0]?._source?.iperf_acceleration;
                console.log(allModems, "modemsssss");
                allModems.map(each=>{
                     let modemStatus =
                      deviceStatusData?.result?.[serialNo]?.[
                        each?.imei
                      ]?.['status'] == 'Eligible';
             
                      let mode = deviceStatusData?.result?.[serialNo]?.[
                          each?.imei
                        ]?.['mode'];
                    let reason =
                      deviceStatusData?.result?.[serialNo]?.[
                        each?.imei
                      ]?.['reason'];
                    
                    let ims_status=each?.IMS_Status;
                    let ims_registeration = each?.IMS_Registration_Status;
                    let voice_config= each?.Voice_CallCfg;
                    let callPossible = each?.IMS_Status!="Disabled";
                    let acc = each?.native_driver
                      ? each?.native_driver == 'disabled'
                        ? 'yes'
                        : each?.native_driver == 'enabled'
                        ? 'no'
                        : 'na'
                      : 'na';
                    if (each?.imei) {
                      imeiModemMap[each?.imei] = modemNames?.[each?.Slot]?.name|| each?.modem_name;
                      modemDataLocal[modemNames?.[each?.Slot]?.name|| each?.modem_name] = {
                        id: modemNames?.[each?.Slot]?.name|| each?.modem_name,
                        name: modemNames?.[each?.Slot]?.name|| each?.modem_name,
                        imei: each?.imei,
                        isBackHaul: each?.mode == 'BackHaul',
                        deviceid: each?.deviceid,
                        status: deviceStatus ? modemStatus : false,
                        reason: reason,
                        mode,
                        ims_status,
                        ims_registeration,
                        voice_config,
                        device_ifs: devicesData?.result?.hits?.[0]?._source?.Iperf_device_if
                          ? devicesData?.result?.hits?.[0]?._source?.Iperf_device_if
                          : [],
                        modem_if: each?.Iperf_modem_if,
                        imsi: each?.IMSI,
                        acc,
                        deviceacc,
                        callPossible,
                        isActiveInterface:
                          each?.Iperf_modem_if == active_interface,
                      };
                     
                    }
                })
            console.log(modemDataLocal)
            platformNo && this.getInterface(platformNo,modemDataLocal,imeiModemMap).then(res=>{
                  resolve(res);
                }); 
               }
            },
            error:(err)=>{
                 this.getInterface(
                  undefined,
                  {},{}
                ).then(res=>{
                  resolve(res);
                });
            }})
          });
        }else{
              this.getInterface(
                  undefined,
                  {},{}
                ).then(res=>{
                  resolve(res);
                });
           }
      })

  }

   getInterface(platfromNo?: any, modemData = {}, imeiModemMap = {}) {
    console.log(platfromNo, modemData, imeiModemMap);
    if(platfromNo){
    return new Promise((resolve, reject)=>{
      this.getHelperTableData(platfromNo).subscribe({
       next:(pf:any)=>{
     if (pf?.result?.hits?.[0]){
      console.log(pf)
       let inerfaceNames = pf?.result?.hits?.[0]?._source?.interfaceNames;
        this.getEdgedevData(platfromNo)
          .subscribe({
            next: (res: any) => {
              if (res?.result?.hits?.[0]) {
                let output = res?.result?.hits?.[0];
                let accessInfo = output?._source?.['Access Info'];
                // let deviceActualData = [];
                let interfaceList = {};
                const interfaceInfoObject = {};
                const interfaces = [];
                console.log(output?._source);
                const wifiSSIDSmap = {};
                if (output?._source?.['WIFI']) {
                  output?._source?.['WIFI'].map((each: any) => {
                    if (each?.networks) {
                      wifiSSIDSmap[each?.interface] = [];
                      each?.networks.map((ss: any) => {
                        wifiSSIDSmap[each?.interface].push(ss);
                      });
                    }
                  });
                }
                if (accessInfo){
                  accessInfo.map((info: any) => {
                    if (info?.type == 'WiFi' && info?.interface) {
                      let interfaceName = info?.interface;

                      info['interfaceName'] = interfaceName;
                      info['deviceid'] = output?._source?.['deviceid'];
                      info['imei'] = interfaceName;
                      info['acc'] = 'na';
                      info['name'] = info?.['MAC'];
                      info['custom_name'] = inerfaceNames?.[interfaceName]
                      info['id'] = interfaceName;
                      info['status'] = true;
                      // info['status'] = info?.status=="enabled"?true:false;
                      // info['device_ifs'] = this.selectedDevice?.[0]?.device_if;
                      info['modem_if'] = interfaceName;
                      info['ssidlist'] = wifiSSIDSmap?.[interfaceName];
                      interfaceList?.[interfaceName]
                        ? interfaceList?.[interfaceName].push(info?.['MAC'])
                        : (interfaceList[interfaceName] = [info?.['MAC']]);
                      imeiModemMap[info?.['MAC']] = interfaceName; 
                      interfaces.push(interfaceName);
                      interfaceInfoObject[interfaceName] = info;
                    } else {
                      if (info?.type == 'WiFi') {
                        let interfaceName: any;
                        for (let each in info) {
                          if (each != 'type' && each != 'MAC') {
                            interfaceName = each;
                          }
                        }
                        wifiSSIDSmap[interfaceName] =
                          output?._source?.['WIFI'];
   
                        info['interfaceName'] = interfaceName;
                        info['deviceid'] = output?._source?.['deviceid'];
                        info['imei'] = interfaceName;
                        info['acc'] = 'na';
                        info['name'] = info?.['MAC'];
                        info['custom_name'] = inerfaceNames?.[interfaceName]
                        info['id'] = interfaceName;
                        info['status'] = true;
                        info['modem_if'] = interfaceName;
                        info['ssidlist'] = wifiSSIDSmap[interfaceName];
                        interfaceList?.[interfaceName]
                          ? interfaceList?.[interfaceName].push(info?.['MAC'])
                          : (interfaceList[interfaceName] = [info?.['MAC']]);
                        imeiModemMap[info?.['MAC']] = interfaceName;  
                        interfaces.push(interfaceName);
                        interfaceInfoObject[interfaceName] = info;
                      }
                    }
                  });
                }
                this.checkModemStatusBase([platfromNo],interfaces)
                  .subscribe({
                    next: (res: any) => {
                      let deviceData = res?.result?.[platfromNo];
                      let deviceStatus =
                        deviceData?.['online'] == 'Yes' &&
                        deviceData?.['status'] == 'Eligible';
                      interfaces.map((each) => {
                        let modemStatus =
                          res?.result?.[platfromNo]?.[each]?.['status'] ==
                          'Eligible';
                        let reason =
                          deviceData?.['online'] != 'Yes'
                            ? deviceData?.['reason'] == 'Device is offline'
                              ? 'Wifi Module Offline'
                              : deviceData?.['reason']
                            : res?.result?.[platfromNo]?.[each]?.['reason']
                            ? res?.result?.[platfromNo]?.[each]?.['reason']
                            : res?.result?.[platfromNo]?.['reason'];
                        if (interfaceInfoObject?.[each]) {
                          interfaceInfoObject[each]['status'] = deviceStatus
                            ? modemStatus
                            : false;
                          interfaceInfoObject[each]['reason'] = reason;
                        }
                        // deviceActualData.push(interfaceInfoObject?.[each]);
                      });
                      const data = {...modemData, ...interfaceInfoObject};
                      resolve({data, imeiModemMap});
                    },
                    error: (e) => {
                    resolve({data:modemData, imeiModemMap});
                    },
                  });
              }else{
               resolve({data:modemData, imeiModemMap});
              }
            },
            error: (e) => {
              resolve({data:modemData, imeiModemMap});
          
            },
          })
         }
       },
       error:(err)=>{
            resolve({data:modemData, imeiModemMap});
      }})
  
    })
    }else{
      return Promise.resolve({data:modemData, imeiModemMap})
    }

  }


    createWalktestTemplate(filter:any){
        return this.httpClient.post(
          `${this.apiEndPoint}/gwdevice/walktest_templates/_create`,
          filter
        );
     }

    deleteWalktestTemplate(id:any){
          return this.httpClient.delete(
           `${this.apiEndPoint}/gwdevice/walktest_templates/${id}`
         );
     }



    getWalktestTemplate(deviceid:any){
      const filter = {"query":{"bool":{"must":[{"query_string":{ "query":deviceid, "type": "phrase", "fields": ["xedge"] } }]
                       }},"sort":{"_kuzzle_info.createdAt":"desc"}}
        return this.httpClient.post(
          `${this.apiEndPoint}/gwdevice/walktest_templates/_search?size=10000`,
          filter
        );
     }

}

